import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b51c501c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "element-loading-text": "数据涉及到大量的查询计算过程，请耐心等待......",
  "element-loading-background": "rgba(0, 0, 0, 0.5)",
  style: {"padding-top":"0px"}
}
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"left"}
}
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  title: "订单已锁定"
}
const _hoisted_6 = {
  key: 1,
  title: "账单已锁定"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  title: "订单已锁定",
  style: {"padding-right":"5px"}
}
const _hoisted_11 = {
  key: 1,
  title: "账单已锁定",
  style: {"padding-right":"5px"}
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { key: 2 }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 1 }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { key: 3 }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { key: 4 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { style: {"width":"100%","word-break":"break-all","text-align":"left"} }
const _hoisted_28 = { key: 5 }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 2 }
const _hoisted_33 = { key: 6 }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { key: 2 }
const _hoisted_37 = { key: 7 }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { key: 1 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { key: 8 }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = { key: 1 }
const _hoisted_45 = { key: 9 }
const _hoisted_46 = { key: 0 }
const _hoisted_47 = { key: 1 }
const _hoisted_48 = { key: 10 }
const _hoisted_49 = ["title"]
const _hoisted_50 = { key: 0 }
const _hoisted_51 = ["title"]
const _hoisted_52 = { key: 11 }
const _hoisted_53 = ["title"]
const _hoisted_54 = { key: 0 }
const _hoisted_55 = ["title"]
const _hoisted_56 = { key: 12 }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = ["title", "onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { key: 1 }
const _hoisted_63 = ["title"]
const _hoisted_64 = { key: 1 }
const _hoisted_65 = { key: 13 }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = { key: 1 }
const _hoisted_68 = {
  key: 0,
  style: {"margin-left":"5px"}
}
const _hoisted_69 = { key: 1 }
const _hoisted_70 = { key: 2 }
const _hoisted_71 = { key: 14 }
const _hoisted_72 = { key: 0 }
const _hoisted_73 = ["onClick"]
const _hoisted_74 = { key: 15 }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = ["onClick"]
const _hoisted_77 = { key: 16 }
const _hoisted_78 = { key: 0 }
const _hoisted_79 = { key: 1 }
const _hoisted_80 = ["title", "onClick"]
const _hoisted_81 = { key: 0 }
const _hoisted_82 = ["title"]
const _hoisted_83 = { key: 0 }
const _hoisted_84 = { key: 17 }
const _hoisted_85 = { key: 0 }
const _hoisted_86 = ["onClick"]
const _hoisted_87 = { class: "link" }
const _hoisted_88 = { class: "link" }
const _hoisted_89 = { class: "link" }
const _hoisted_90 = { class: "link" }
const _hoisted_91 = {
  style: {"top":"3.3px","z-index":"0"},
  class: "count-result"
}
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_93 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_94 = { style: {"width":"100%"} }
const _hoisted_95 = { style: {"float":"left","width":"25%"} }
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "账单合计", -1))
const _hoisted_97 = { style: {"padding-left":"10px"} }
const _hoisted_98 = { style: {"float":"left","width":"25%"} }
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发票状态", -1))
const _hoisted_100 = { style: {"padding-left":"10px"} }
const _hoisted_101 = { style: {"float":"left","width":"25%"} }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发票合计", -1))
const _hoisted_103 = { style: {"padding-left":"10px"} }
const _hoisted_104 = { style: {"float":"left","width":"25%"} }
const _hoisted_105 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发票换算合计", -1))
const _hoisted_106 = { style: {"padding-left":"10px"} }
const _hoisted_107 = { style: {"clear":"both","width":"100%","height":"30px"} }
const _hoisted_108 = {
  key: 0,
  style: {"color":"red","height":"30px","line-height":"30px"}
}
const _hoisted_109 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_110 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_111 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_112 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_113 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_114 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_115 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_116 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_117 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_118 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_119 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_120 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_122 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_123 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_124 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_125 = { style: {"width":"100% !important","overflow":"hidden","height":"40px","text-align":"left"} }
const _hoisted_126 = { key: 0 }
const _hoisted_127 = { key: 0 }
const _hoisted_128 = { key: 1 }
const _hoisted_129 = {
  key: 1,
  style: {"font-size":"18px","float":"left"}
}
const _hoisted_130 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_131 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_132 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c","float":"left"} }, "*", -1))
const _hoisted_134 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_135 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_136 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_137 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_138 = { style: {"width":"100% !important","overflow":"hidden","height":"46px"} }
const _hoisted_139 = ["onClick"]
const _hoisted_140 = {
  key: 0,
  style: {"font-size":"13px","color":"#fe995b","font-weight":"900","padding-top":"15px"}
}
const _hoisted_141 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_142 = { style: {"clear":"both"} }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_144 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_145 = { style: {"width":"100% !important"} }
const _hoisted_146 = {
  key: 0,
  style: {"font-size":"13px","color":"red","font-weight":"900","margin-left":"10px"}
}
const _hoisted_147 = { key: 0 }
const _hoisted_148 = { key: 1 }
const _hoisted_149 = {
  key: 2,
  style: {"font-size":"13px","color":"#fe995b","font-weight":"900","margin-left":"10px"}
}
const _hoisted_150 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_151 = { key: 0 }
const _hoisted_152 = {
  key: 0,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_153 = {
  key: 1,
  style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_154 = { key: 1 }
const _hoisted_155 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_156 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_157 = { key: 0 }
const _hoisted_158 = { key: 1 }
const _hoisted_159 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_160 = { key: 0 }
const _hoisted_161 = { key: 1 }
const _hoisted_162 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_163 = { key: 0 }
const _hoisted_164 = { key: 0 }
const _hoisted_165 = { key: 1 }
const _hoisted_166 = { key: 1 }
const _hoisted_167 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_168 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_169 = { style: {"width":"100%","word-break":"break-all","text-align":"left","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_170 = ["onClick"]
const _hoisted_171 = ["onClick"]
const _hoisted_172 = ["onClick"]
const _hoisted_173 = ["onClick"]
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"float":"left"} }, "历史记录", -1))
const _hoisted_175 = { style: {"float":"right"} }
const _hoisted_176 = { key: 0 }
const _hoisted_177 = { style: {"font-size":"13px"} }
const _hoisted_178 = ["onClick"]
const _hoisted_179 = { style: {"float":"left"} }
const _hoisted_180 = { style: {"font-weight":"900"} }
const _hoisted_181 = { key: 0 }
const _hoisted_182 = {
  key: 0,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_183 = {
  key: 1,
  style: {"margin-left":"3px","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
}
const _hoisted_184 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_185 = {
  key: 0,
  style: {"line-height":"28px"}
}
const _hoisted_186 = {
  key: 0,
  style: {"clear":"both"}
}
const _hoisted_187 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_188 = {
  key: 1,
  style: {"float":"left"}
}
const _hoisted_189 = {
  key: 0,
  style: {}
}
const _hoisted_190 = { key: 0 }
const _hoisted_191 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_192 = { style: {"font-weight":"900"} }
const _hoisted_193 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_194 = { style: {"font-weight":"900"} }
const _hoisted_195 = {
  key: 2,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_196 = { style: {"font-weight":"900"} }
const _hoisted_197 = {
  key: 3,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_198 = { style: {} }
const _hoisted_199 = ["onClick"]
const _hoisted_200 = ["onClick"]
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_202 = { key: 1 }
const _hoisted_203 = { key: 0 }
const _hoisted_204 = { key: 1 }
const _hoisted_205 = {
  key: 0,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_206 = { style: {"font-weight":"900"} }
const _hoisted_207 = {
  key: 1,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_208 = { style: {"font-weight":"900"} }
const _hoisted_209 = {
  key: 2,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_210 = { style: {"font-weight":"900"} }
const _hoisted_211 = {
  key: 3,
  style: {"text-indent":"20px","float":"left"}
}
const _hoisted_212 = { style: {} }
const _hoisted_213 = ["onClick"]
const _hoisted_214 = ["onClick"]
const _hoisted_215 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_216 = { key: 1 }
const _hoisted_217 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_218 = {
  key: 1,
  style: {"clear":"both"}
}
const _hoisted_219 = { key: 0 }
const _hoisted_220 = {
  key: 0,
  style: {"text-indent":"20px"}
}
const _hoisted_221 = { style: {"font-weight":"900"} }
const _hoisted_222 = {
  key: 1,
  style: {"text-indent":"20px"}
}
const _hoisted_223 = { style: {"font-weight":"900"} }
const _hoisted_224 = {
  key: 2,
  style: {"text-indent":"20px"}
}
const _hoisted_225 = { style: {"font-weight":"900"} }
const _hoisted_226 = {
  key: 3,
  style: {"text-indent":"20px"}
}
const _hoisted_227 = { style: {} }
const _hoisted_228 = { key: 1 }
const _hoisted_229 = {
  key: 0,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_230 = {
  key: 1,
  style: {"float":"left","text-indent":"20px"}
}
const _hoisted_231 = { style: {"float":"left","text-indent":"20px"} }
const _hoisted_232 = {
  key: 0,
  style: {"text-indent":"20px"}
}
const _hoisted_233 = { style: {"font-weight":"900"} }
const _hoisted_234 = {
  key: 1,
  style: {"text-indent":"20px"}
}
const _hoisted_235 = { style: {"font-weight":"900"} }
const _hoisted_236 = {
  key: 2,
  style: {"text-indent":"20px"}
}
const _hoisted_237 = { style: {"font-weight":"900"} }
const _hoisted_238 = {
  key: 3,
  style: {"text-indent":"20px"}
}
const _hoisted_239 = { style: {} }
const _hoisted_240 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both"} }, null, -1))
const _hoisted_242 = {
  key: 1,
  style: {"height":"40px","line-height":"40px","text-align":"center","font-size":"14px","color":"#999"}
}
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"90px"} }, null, -1))
const _hoisted_244 = { style: {"clear":"both"} }
const _hoisted_245 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_246 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_247 = { style: {"width":"100% !important"} }
const _hoisted_248 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"90px"} }, null, -1))
const _hoisted_249 = { style: {"clear":"both"} }
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_251 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_252 = { style: {"width":"100% !important"} }
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"90px"} }, null, -1))
const _hoisted_254 = { style: {"clear":"both"} }
const _hoisted_255 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 统计 ", -1))
const _hoisted_256 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_257 = ["innerHTML"]
const _hoisted_258 = { style: {"width":"100% !important"} }
const _hoisted_259 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_260 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_261 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_262 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_263 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_264 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_265 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_266 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_267 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","text-align":"left","line-height":"30px"} }
const _hoisted_268 = { key: 0 }
const _hoisted_269 = ["onClick"]
const _hoisted_270 = { key: 1 }
const _hoisted_271 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_272 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","text-align":"left","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_273 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_274 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_275 = { style: {"width":"calc(100% - 14px)","display":"inline-block","float":"left","margin-left":"7px"} }
const _hoisted_276 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","text-align":"left","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_277 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_278 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_279 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","text-align":"left","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_280 = {
  key: 0,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_281 = {
  key: 1,
  style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"}
}
const _hoisted_282 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","text-align":"left","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_283 = { key: 0 }
const _hoisted_284 = { key: 1 }
const _hoisted_285 = { key: 2 }
const _hoisted_286 = { style: {"width":"100% !important","overflow":"hidden","height":"30px","line-height":"30px","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_287 = ["onClick"]
const _hoisted_288 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_289 = { style: {"clear":"both"} }
const _hoisted_290 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_291 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_292 = { style: {"width":"100% !important"} }
const _hoisted_293 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_294 = { style: {"width":"100%","height":"30px","line-height":"30px","word-break":"break-all","text-align":"left","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_295 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_296 = { style: {"width":"100%","height":"30px","line-height":"30px","word-break":"break-all","text-align":"left","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_297 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_298 = { key: 0 }
const _hoisted_299 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_300 = { key: 0 }
const _hoisted_301 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_302 = { key: 0 }
const _hoisted_303 = { style: {"margin":"0px"} }
const _hoisted_304 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_305 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_306 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_307 = { key: 0 }
const _hoisted_308 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_309 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_310 = { style: {"clear":"both"} }
const _hoisted_311 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_312 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_313 = { style: {"width":"100% !important"} }
const _hoisted_314 = ["innerHTML"]
const _hoisted_315 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_316 = { style: {"width":"100%","height":"30px","line-height":"30px","word-break":"break-all","text-align":"left","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_317 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_318 = { style: {"width":"100%","height":"30px","line-height":"30px","word-break":"break-all","text-align":"left","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"} }
const _hoisted_319 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_320 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_321 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_322 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_323 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_324 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_325 = ["onClick"]
const _hoisted_326 = { style: {"float":"left","width":"150px"} }
const _hoisted_327 = { style: {"margin":"0px"} }
const _hoisted_328 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_329 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_330 = { style: {"margin":"0px"} }
const _hoisted_331 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*", -1))
const _hoisted_332 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_333 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_334 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_335 = { style: {"width":"100% !important"} }
const _hoisted_336 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_337 = { style: {"clear":"both"} }
const _hoisted_338 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { style: {"font-weight":"900","font-size":"14px"} }, [
    /*#__PURE__*/_createTextVNode(" 1、应收/应付合计根据搜索结果统计得出，毛利合计=应收合计-应付合计， 应收/应付合计"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "红色字体"),
    /*#__PURE__*/_createTextVNode("表示全部未核销； 应收/应付合计"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"#fe995b"} }, "橙色字体"),
    /*#__PURE__*/_createTextVNode("表示部分核销； 应收/应付合计"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"black"} }, "黑色字体"),
    /*#__PURE__*/_createTextVNode("表示全部核销。 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","font-weight":"900","font-size":"14px","padding-top":"5px"} }, [
    /*#__PURE__*/_createTextVNode(" 2、单项合计"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "红色字体"),
    /*#__PURE__*/_createTextVNode("表示该信息为未提交状态 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","font-weight":"900","font-size":"14px","padding-top":"5px"} }, [
    /*#__PURE__*/_createTextVNode(" 3、Booking No"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "红色字体"),
    /*#__PURE__*/_createTextVNode("表示委托已取消 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","font-weight":"900","font-size":"14px","padding-top":"5px"} }, [
    /*#__PURE__*/_createTextVNode(" 4、订单编号"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "红色字体"),
    /*#__PURE__*/_createTextVNode("表示订单已取消 ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","font-weight":"900","font-size":"14px","padding-top":"5px"} }, [
    /*#__PURE__*/_createTextVNode(" 5、发票号码"),
    /*#__PURE__*/_createElementVNode("span", { style: {"color":"red"} }, "红色字体"),
    /*#__PURE__*/_createTextVNode("表示发票金额与账单金额不一致 ")
  ])
], -1))
const _hoisted_339 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_340 = ["innerHTML"]
const _hoisted_341 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_342 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 关联发票 ", -1))
const _hoisted_343 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_344 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_345 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_346 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_347 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_348 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_349 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_350 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_351 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_352 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_353 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_354 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_355 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_356 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_357 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_358 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_359 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_360 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 对账状态 ", -1))
const _hoisted_361 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_362 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_363 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 编辑 ", -1))
const _hoisted_364 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_365 = { style: {"text-align":"center","margin-top":"20px"} }
const _hoisted_366 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 部分核销 ", -1))
const _hoisted_367 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_368 = { style: {"width":"100% !important"} }
const _hoisted_369 = { style: {"width":"100% !important","overflow":"hidden","height":"50px","line-height":"30px"} }
const _hoisted_370 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0px"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*"),
  /*#__PURE__*/_createTextVNode(" 核销币制 ")
], -1))
const _hoisted_371 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_372 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0px"} }, "本次核销", -1))
const _hoisted_373 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_374 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0px"} }, "核销时间", -1))
const _hoisted_375 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_376 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin":"0px"} }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"color":"#f56c6c"} }, "*"),
  /*#__PURE__*/_createTextVNode(" 汇率 ")
], -1))
const _hoisted_377 = { style: {"width":"100% !important","overflow":"hidden","height":"50px"} }
const _hoisted_378 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_379 = { style: {"clear":"both"} }
const _hoisted_380 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 账期 ", -1))
const _hoisted_381 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_382 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_383 = { style: {"clear":"both"} }
const _hoisted_384 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"40px","line-height":"40px","float":"left","margin-top":"-15px"} }, " 财务周期 ", -1))
const _hoisted_385 = { style: {"float":"right","height":"40px","line-height":"40px","margin-top":"-10px","margin-right":"-10px"} }
const _hoisted_386 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"clear":"both","height":"20px"} }, null, -1))
const _hoisted_387 = { style: {"clear":"both"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_Lock = _resolveComponent("Lock")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_Minus = _resolveComponent("Minus")!
  const _component_miezz_select = _resolveComponent("miezz-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_miezz_page_list = _resolveComponent("miezz-page-list")!
  const _component_bill_detail = _resolveComponent("bill-detail")!
  const _component_miezz_modal = _resolveComponent("miezz-modal")!
  const _component_bill_form = _resolveComponent("bill-form")!
  const _component_CloseBold = _resolveComponent("CloseBold")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_miezz_text_ellipsis = _resolveComponent("miezz-text-ellipsis")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_miezz_input = _resolveComponent("miezz-input")!
  const _component_miezz_thumbnail = _resolveComponent("miezz-thumbnail")!
  const _component_miezz_upload = _resolveComponent("miezz-upload")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_miezz_button_bar = _resolveComponent("miezz-button-bar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_Edit = _resolveComponent("Edit")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")!
  const _component_el_timeline = _resolveComponent("el-timeline")!
  const _component_Document = _resolveComponent("Document")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_miezz_currency = _resolveComponent("miezz-currency")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createVNode(_component_miezz_page_list, {
        modelValue: _ctx.list,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.list) = $event)),
        onHandleSelect: _ctx.handleSelectionChange,
        ref: "$FinanceTable",
        onHandleTopButtonClick: _ctx.handleTopButtonClick,
        onHandleRowButtonClick: _ctx.handleRowButtonClick,
        isDefaultTip: false,
        onHandleBottomButtonClick: _ctx.handleBottomButtonClick
      }, {
        column: _withCtx(({ model, row }) => [
          (model.Prop == 'BookingNo')
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                (
              row.BookingNo != null &&
              row.BookingNo != undefined &&
              row.IsLock == true &&
              (row.FromId == null ||
                row.FromId == undefined ||
                row.FromId == '')
            )
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      title: "订单已锁定",
                      style: {"padding-right":"5px"},
                      class: _normalizeClass(row.Pool && row.Pool.Status == 40 ? 'err' : 'warn')
                    }, [
                      _createVNode(_component_el_icon, { class: "err" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_Lock)
                        ]),
                        _: 1
                      })
                    ], 2))
                  : (
              row.BookingNo != null &&
              row.BookingNo != undefined &&
              row.IsSave == true &&
              (row.FromId == null ||
                row.FromId == undefined ||
                row.FromId == '')
            )
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 1,
                        title: "账单已锁定",
                        style: {"padding-right":"5px"},
                        class: _normalizeClass(row.Pool && row.Pool.Status == 40 ? 'err' : 'warn')
                      }, [
                        _createVNode(_component_el_icon, { class: "warn" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Lock)
                          ]),
                          _: 1
                        })
                      ], 2))
                    : _createCommentVNode("", true),
                (row.BookingNo == null || row.BookingNo == undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                      (row.Type == 20)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                            (
                  row.IsLock == true &&
                  (row.FromId == null ||
                    row.FromId == undefined ||
                    row.FromId == '')
                )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                  _createElementVNode("span", {
                                    style: _normalizeStyle([{"padding-right":"5px","margin-left":"-20px"}, 
                    (row.Child == null ||
                      row.Child == undefined ||
                      row.Child.length <= 0) &&
                    (row.PoolId == undefined ||
                      row.PoolId == null ||
                      row.PoolId == '')
                      ? 'margin-left:0px;'
                      : ''
                  ]),
                                    class: _normalizeClass(row.Pool && row.Pool.Status == 40 ? 'err' : 'warn')
                                  }, [
                                    _createVNode(_component_el_icon, { class: "err" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Lock)
                                      ]),
                                      _: 1
                                    })
                                  ], 6)
                                ]))
                              : (
                  row.IsSave == true &&
                  (row.FromId == null ||
                    row.FromId == undefined ||
                    row.FromId == '')
                )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                                    _createElementVNode("span", {
                                      style: _normalizeStyle([{"padding-right":"5px","margin-left":"-20px"}, 
                    (row.Child == null ||
                      row.Child == undefined ||
                      row.Child.length <= 0) &&
                    (row.PoolId == undefined ||
                      row.PoolId == null ||
                      row.PoolId == '')
                      ? 'margin-left:0px;'
                      : ''
                  ]),
                                      class: _normalizeClass(row.Pool && row.Pool.Status == 40 ? 'err' : 'warn')
                                    }, [
                                      _createVNode(_component_el_icon, { class: "warn" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Lock)
                                        ]),
                                        _: 1
                                      })
                                    ], 6)
                                  ]))
                                : _createCommentVNode("", true),
                            (
                  row.Child != null &&
                  row.Child != undefined &&
                  row.Child.length > 0
                )
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  onClick: ($event: any) => (_ctx.onChild(row)),
                                  style: {"cursor":"pointer"}
                                }, [
                                  (row.IsOpen == false)
                                    ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Plus)
                                        ]),
                                        _: 1
                                      }))
                                    : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Minus)
                                        ]),
                                        _: 1
                                      })),
                                  _createTextVNode(" 已分摊 ")
                                ], 8, _hoisted_7))
                              : (_openBlock(), _createElementBlock("span", _hoisted_8, " 未分摊 "))
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                            (
                  row.IsLock == true &&
                  (row.FromId == null ||
                    row.FromId == undefined ||
                    row.FromId == '')
                )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                                  _createVNode(_component_el_icon, { class: "err" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Lock)
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (
                  row.IsSave == true &&
                  (row.FromId == null ||
                    row.FromId == undefined ||
                    row.FromId == '')
                )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                                    _createVNode(_component_el_icon, { class: "warn" }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Lock)
                                      ]),
                                      _: 1
                                    })
                                  ]))
                                : _createCommentVNode("", true),
                            _createTextVNode(" 暂无数据 ")
                          ]))
                    ]))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 3,
                      onClick: ($event: any) => (_ctx.onPool(row)),
                      style: {"width":"100%","word-break":"break-all","text-align":"left","cursor":"pointer"},
                      class: _normalizeClass(row.Pool && row.Pool.Status == 40 ? 'err' : 'warn')
                    }, _toDisplayString(row.BookingNo), 11, _hoisted_12))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'Code')
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                (row.Code == null || row.Code == undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, "暂无数据"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_15, [
                      (_ctx.OrderManagement_Order_Summary == true)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: ($event: any) => (_ctx.onOrder(row)),
                            style: {"width":"100%","word-break":"break-all","text-align":"left","cursor":"pointer"},
                            class: _normalizeClass(row.Order && row.Order.Status == 40 ? 'err' : 'warn')
                          }, _toDisplayString(row.Code), 11, _hoisted_16))
                        : (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: _normalizeClass(row.Order && row.Order.Status == 40 ? 'err' : 'warn')
                          }, _toDisplayString(row.Code), 3))
                    ]))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'BLNO')
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                (row.BLNO == null || row.BLNO == undefined || row.BLNO == '')
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      onClick: ($event: any) => (_ctx.onBookingNo(row)),
                      style: {"cursor":"pointer","color":"#fe995b"}
                    }, "暂无数据", 8, _hoisted_18))
                  : (_openBlock(), _createElementBlock("span", _hoisted_19, [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.onBLNO(row)),
                        style: {"width":"100%","word-break":"break-all","text-align":"left","cursor":"pointer","color":"#fe995b"}
                      }, _toDisplayString(row.BLNO), 9, _hoisted_20)
                    ]))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'BillObject')
            ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                (
              row.BillObjectId != null &&
              row.BillObjectId != undefined &&
              row.BillObjectId != '' &&
              row.BillObject != null &&
              row.BillObject != undefined &&
              row.BillObject != ''
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(row.BillObject), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_23, "暂无数据"))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'SalerName')
            ? (_openBlock(), _createElementBlock("span", _hoisted_24, [
                (row.SalerName == null || row.SalerName == undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, "暂无数据"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_26, [
                      _createElementVNode("span", _hoisted_27, _toDisplayString(row.SalerName), 1)
                    ]))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'UnitPrice')
            ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                (
              row.FromId != null && row.FromId != undefined && row.FromId != ''
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_29, "—"))
                  : (
              row.UnitPrice != null &&
              row.UnitPrice != undefined &&
              row.UnitPrice != ''
            )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                        (
                row.CurrencySystem != null && row.CurrencySystem != undefined
              )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(row.CurrencySystem.Code), 1))
                          : _createCommentVNode("", true),
                        _createTextVNode(_toDisplayString(_ctx.formatNumber(row.UnitPrice)), 1)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_32, "暂无数据"))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'TaxRate')
            ? (_openBlock(), _createElementBlock("span", _hoisted_33, [
                (
              row.FromId != null && row.FromId != undefined && row.FromId != ''
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_34, "—"))
                  : (
              row.TaxRate != null &&
              row.TaxRate != undefined &&
              row.TaxRate != ''
            )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(row.TaxRate), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_36, "暂无数据"))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'CostId')
            ? (_openBlock(), _createElementBlock("span", _hoisted_37, [
                (row.Cost != null && row.Cost != undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_38, [
                      (row.Cost != null)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(row.Cost.FullName), 1))
                        : _createCommentVNode("", true),
                      (row.FromId != null && row.FromId != undefined)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, "分摊"))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_41, "暂无数据"))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'CurrencySystemId')
            ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                (row.CurrencySystem != null && row.CurrencySystem != undefined)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_43, _toDisplayString(row.CurrencySystem.Code), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_44, "暂无数据"))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'Remark')
            ? (_openBlock(), _createElementBlock("span", _hoisted_45, [
                (
              row.Remark != null && row.Remark != undefined && row.Remark != ''
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(row.Remark), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_47, "暂无数据"))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'TaxAmount')
            ? (_openBlock(), _createElementBlock("span", _hoisted_48, [
                (
              row.TaxAmount != null &&
              row.TaxAmount != undefined &&
              row.TaxAmount != ''
            )
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      title: row.IsSave != true ? '该账单还没保存' : ''
                    }, [
                      (
                row.CurrencySystem != null && row.CurrencySystem != undefined
              )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_50, _toDisplayString(row.CurrencySystem.Code), 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(_toDisplayString(_ctx.formatNumber(row.TaxAmount)), 1)
                    ], 8, _hoisted_49))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      title: row.IsSave != true ? '该账单还没保存' : ''
                    }, "暂无数据", 8, _hoisted_51))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'TotalPrice')
            ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                (
              row.TotalPrice != null &&
              row.TotalPrice != undefined &&
              row.TotalPrice != ''
            )
                  ? (_openBlock(), _createElementBlock("span", {
                      key: 0,
                      style: _normalizeStyle(row.IsSave != true ? 'color:red;' : ''),
                      title: row.IsSave != true ? '该账单还没保存' : ''
                    }, [
                      (
                row.CurrencySystem != null && row.CurrencySystem != undefined
              )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(row.CurrencySystem.Code), 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(_toDisplayString(_ctx.formatNumber(row.TotalPrice)), 1)
                    ], 12, _hoisted_53))
                  : (_openBlock(), _createElementBlock("span", {
                      key: 1,
                      style: _normalizeStyle(row.IsSave != true ? 'color:red;' : ''),
                      title: row.IsSave != true ? '该账单还没保存' : ''
                    }, "暂无数据", 12, _hoisted_55))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'FinancialCycleString')
            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                (
              row.FromId != null && row.FromId != undefined && row.FromId != ''
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_57, "—"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      (_ctx.FinancialManagement_BillSummary_FinancialCycle == true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                            (
                  row.FinancialCycleString != null &&
                  row.FinancialCycleString != undefined &&
                  row.FinancialCycleString != ''
                )
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  title: '业务周期：' + row.BusinessCycleString,
                                  style: {"color":"#fe995b","cursor":"pointer"},
                                  onClick: ($event: any) => (_ctx.onFinancialCycle(row))
                                }, _toDisplayString(row.FinancialCycleString), 9, _hoisted_60))
                              : (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  style: {"color":"#fe995b","cursor":"pointer"},
                                  onClick: ($event: any) => (_ctx.onFinancialCycle(row))
                                }, "暂无数据", 8, _hoisted_61))
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                            (
                  row.FinancialCycleString != null &&
                  row.FinancialCycleString != undefined &&
                  row.FinancialCycleString != ''
                )
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  title: '业务周期：' + row.BusinessCycleString
                                }, _toDisplayString(row.FinancialCycleString), 9, _hoisted_63))
                              : (_openBlock(), _createElementBlock("span", _hoisted_64, "暂无数据"))
                          ]))
                    ]))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'FirstChargeUnitNumber')
            ? (_openBlock(), _createElementBlock("span", _hoisted_65, [
                (
              row.FromId != null && row.FromId != undefined && row.FromId != ''
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, "—"))
                  : (
              (row.FirstChargeUnitNumber != null &&
                row.FirstChargeUnitNumber != undefined) ||
              (row.FirstChargeUnit != null && row.FirstChargeUnit != undefined)
            )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_67, [
                        (
                row.FirstChargeUnit != null && row.FirstChargeUnit != undefined
              )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(row.FirstChargeUnit.FullName), 1))
                          : _createCommentVNode("", true),
                        (
                row.FirstChargeUnitNumber != null &&
                row.FirstChargeUnitNumber != undefined
              )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_69, "×" + _toDisplayString(row.FirstChargeUnitNumber), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_70, "暂无数据"))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'InvoiceNumber')
            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                (
              row.FromId != null && row.FromId != undefined && row.FromId != ''
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_72, "—"))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.onInvoice(row)),
                      style: _normalizeStyle([{"cursor":"pointer","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}, 
              row.IsInvoiceSame == false ? 'color:red;' : 'color: #fe995b; '
            ])
                    }, _toDisplayString(_ctx.isString(row.InvoiceNumber)), 13, _hoisted_73))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'SettlementType')
            ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                (
              row.FromId != null && row.FromId != undefined && row.FromId != ''
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_75, "—"))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.onSettlement(row)),
                      style: {"cursor":"pointer","color":"#fe995b","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
                    }, _toDisplayString(_ctx.isString(row.SettlementTypeString)), 9, _hoisted_76))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'AccountPeriodString')
            ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                (
              row.FromId != null && row.FromId != undefined && row.FromId != ''
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_78, "—"))
                  : (_openBlock(), _createElementBlock("div", _hoisted_79, [
                      (
                _ctx.FinancialManagement_BillSummary_AccountingPeriodremainingDays ==
                true
              )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            title: 
                row.StartDateString != null &&
                row.StartDate != undefined &&
                row.StartDateString != ''
                  ? '记账起始日期：' + row.StartDateString
                  : ''
              ,
                            onClick: ($event: any) => (_ctx.onAccountPeriod(row)),
                            style: _normalizeStyle(
                row.SurplusDays < 0
                  ? 'color:red;cursor:pointer;'
                  : 'color: #fe995b;cursor:pointer;'
              )
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.isString(row.AccountPeriod)) + " ", 1),
                            (
                  row.SurplusDayString != null &&
                  row.SurplusDayString != undefined &&
                  row.SurplusDayString != ''
                )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_81, "/" + _toDisplayString(row.SurplusDayString), 1))
                              : _createCommentVNode("", true)
                          ], 12, _hoisted_80))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            title: 
                row.StartDateString != null &&
                row.StartDate != undefined &&
                row.StartDateString != ''
                  ? '记账起始日期：' + row.StartDateString
                  : ''
              ,
                            style: _normalizeStyle(row.SurplusDays < 0 ? 'color:red;' : '')
                          }, [
                            _createTextVNode(_toDisplayString(_ctx.isString(row.AccountPeriod)) + " ", 1),
                            (
                  row.SurplusDayString != null &&
                  row.SurplusDayString != undefined &&
                  row.SurplusDayString != ''
                )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_83, "/" + _toDisplayString(row.SurplusDayString), 1))
                              : _createCommentVNode("", true)
                          ], 12, _hoisted_82))
                    ]))
              ]))
            : _createCommentVNode("", true),
          (model.Prop == 'CheckStatusString')
            ? (_openBlock(), _createElementBlock("div", _hoisted_84, [
                (
              row.FromId != null && row.FromId != undefined && row.FromId != ''
            )
                  ? (_openBlock(), _createElementBlock("span", _hoisted_85, "—"))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      onClick: ($event: any) => (_ctx.onCheckStatus(row)),
                      style: {"cursor":"pointer","color":"#fe995b","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap"}
                    }, _toDisplayString(_ctx.isString(row.CheckStatusString)), 9, _hoisted_86))
              ]))
            : _createCommentVNode("", true)
        ]),
        "dynamic-search-customize": _withCtx(({ model }) => [
          (model.Where.Prop == 'DynamicSearch_Type')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 0,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.types
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : _createCommentVNode("", true),
          (model.Where.Prop == 'DynamicSearch_BusinessDate')
            ? (_openBlock(), _createBlock(_component_el_date_picker, {
                key: 1,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                "value-format": "YYYY/MM",
                type: "monthrange",
                format: "YYYY/MM",
                "range-separator": "到",
                "start-placeholder": "开始月份",
                "end-placeholder": "结束月份"
              }, null, 8, ["modelValue", "onUpdate:modelValue"]))
            : _createCommentVNode("", true),
          (model.Where.Prop == 'DynamicSearch_SettlementType')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 2,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.searchSettlements
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : _createCommentVNode("", true),
          (model.Where.Prop == 'DynamicSearch_LoadingPortId')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 3,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.loadingPorts,
                clearable: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : _createCommentVNode("", true),
          (model.Where.Prop == 'DynamicSearch_CurrencySystem')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 4,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.currencys,
                clearable: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : _createCommentVNode("", true),
          (model.Where.Prop == 'DynamicSearch_BLNO')
            ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                key: 5,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                clearable: true,
                style: {"width":"100% !important"},
                "fetch-suggestions": _ctx.querySearchBLNOAsync,
                "popper-class": "my-autocomplete",
                placeholder: "请填写关键词",
                onSelect: ($event: any) => (_ctx.handleSelectBLNO($event, model))
              }, {
                default: _withCtx(({ item }) => [
                  _createElementVNode("span", _hoisted_87, _toDisplayString(item.Label), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onSelect"]))
            : _createCommentVNode("", true),
          (model.Where.Prop == 'DynamicSearch_SalerId')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 6,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.salers,
                clearable: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : _createCommentVNode("", true),
          (model.Where.Prop == 'DynamicSearch_ClientCompany')
            ? (_openBlock(), _createBlock(_component_miezz_select, {
                key: 7,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                options: _ctx.clients,
                clearable: ""
              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
            : _createCommentVNode("", true),
          (model.Where.Prop == 'DynamicSearch_Cost')
            ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                key: 8,
                modelValue: model.Where.Value,
                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                clearable: true,
                style: {"width":"100% !important"},
                "fetch-suggestions": _ctx.querySearchCostAsync,
                "popper-class": "my-autocomplete",
                placeholder: "请填写关键词",
                onSelect: ($event: any) => (_ctx.handleSelectCost($event, model))
              }, {
                default: _withCtx(({ item }) => [
                  _createElementVNode("span", _hoisted_88, _toDisplayString(item.Label), 1)
                ]),
                _: 2
              }, 1032, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onSelect"]))
            : (model.Where.Prop == 'DynamicSearch_DeliveryPortId')
              ? (_openBlock(), _createBlock(_component_miezz_select, {
                  key: 9,
                  modelValue: model.Where.Value,
                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                  options: _ctx.deliveryPorts,
                  clearable: ""
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
              : (model.Where.Prop == 'DynamicSearch_SubmitStatus')
                ? (_openBlock(), _createBlock(_component_miezz_select, {
                    key: 10,
                    modelValue: model.Where.Value,
                    "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                    options: _ctx.EnumSubmitStatusOption,
                    clearable: ""
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                : (model.Where.Prop == 'DynamicSearch_OverdueStatus')
                  ? (_openBlock(), _createBlock(_component_miezz_select, {
                      key: 11,
                      modelValue: model.Where.Value,
                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                      options: _ctx.EnumOverdueStatusOption,
                      clearable: ""
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                  : (model.Where.Prop == 'DynamicSearch_IsBad')
                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                        key: 12,
                        modelValue: model.Where.Value,
                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                        options: _ctx.EnumOverdueStatusOption,
                        clearable: ""
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                    : (model.Where.Prop == 'DynamicSearch_DeliveryPlaceLabel')
                      ? (_openBlock(), _createBlock(_component_miezz_select, {
                          key: 13,
                          modelValue: model.Where.Value,
                          "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                          options: _ctx.deliveryPlaces,
                          clearable: ""
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                      : (model.Where.Prop == 'DynamicSearch_ServiceRemark')
                        ? (_openBlock(), _createBlock(_component_miezz_select, {
                            key: 14,
                            modelValue: model.Where.Value,
                            "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                            options: _ctx.serviceRemarks,
                            clearable: ""
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                        : (model.Where.Prop == 'DynamicSearch_CustomerServiceId')
                          ? (_openBlock(), _createBlock(_component_miezz_select, {
                              key: 15,
                              modelValue: model.Where.Value,
                              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                              options: _ctx.customerServices,
                              clearable: ""
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                          : (model.Where.Prop == 'DynamicSearch_PoolCustomer')
                            ? (_openBlock(), _createBlock(_component_miezz_select, {
                                key: 16,
                                modelValue: model.Where.Value,
                                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                options: _ctx.poolCustomers,
                                clearable: ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                            : (model.Where.Prop == 'DynamicSearch_InvoiceState')
                              ? (_openBlock(), _createBlock(_component_miezz_select, {
                                  key: 17,
                                  modelValue: model.Where.Value,
                                  "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                  options: _ctx.EnumInvoiceStatusOptionSearch,
                                  clearable: ""
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                              : (model.Where.Prop == 'DynamicSearch_InvoiceSettlementState')
                                ? (_openBlock(), _createBlock(_component_miezz_select, {
                                    key: 18,
                                    modelValue: model.Where.Value,
                                    "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                    options: _ctx.EnumInvoiceSettlementStatusOptionSearch,
                                    clearable: ""
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                : (model.Where.Prop == 'DynamicSearch_CheckStatus')
                                  ? (_openBlock(), _createBlock(_component_miezz_select, {
                                      key: 19,
                                      modelValue: model.Where.Value,
                                      "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                      options: _ctx.EnumBillCheckStatusOptionSearch,
                                      clearable: ""
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                  : (model.Where.Prop == 'DynamicSearch_ShareStatus')
                                    ? (_openBlock(), _createBlock(_component_miezz_select, {
                                        key: 20,
                                        modelValue: model.Where.Value,
                                        "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                        options: _ctx.EnumBillShareStatusOptionSearch,
                                        clearable: ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                    : (model.Where.Prop == 'DynamicSearch_Source')
                                      ? (_openBlock(), _createBlock(_component_miezz_select, {
                                          key: 21,
                                          modelValue: model.Where.Value,
                                          "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                          options: _ctx.companySources,
                                          clearable: ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                      : (model.Where.Prop == 'DynamicSearch_Object')
                                        ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                                            key: 22,
                                            modelValue: model.Where.Value,
                                            "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                            clearable: true,
                                            style: {"width":"100% !important"},
                                            "fetch-suggestions": _ctx.querySearchObjectAsync,
                                            "popper-class": "my-autocomplete",
                                            placeholder: "请填写关键词",
                                            onSelect: ($event: any) => (_ctx.handleSelectObject($event, model))
                                          }, {
                                            default: _withCtx(({ item }) => [
                                              _createElementVNode("span", _hoisted_89, _toDisplayString(item.Label), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onSelect"]))
                                        : (model.Where.Prop == 'DynamicSearch_BoxNumber')
                                          ? (_openBlock(), _createBlock(_component_el_autocomplete, {
                                              key: 23,
                                              modelValue: model.Where.Value,
                                              "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                              clearable: true,
                                              style: {"width":"100% !important"},
                                              "fetch-suggestions": _ctx.querySearchBoxNumberAsync,
                                              "popper-class": "my-autocomplete",
                                              placeholder: "请填写关键词",
                                              onSelect: ($event: any) => (_ctx.handleSelectBoxNumber($event, model))
                                            }, {
                                              default: _withCtx(({ item }) => [
                                                _createElementVNode("span", _hoisted_90, _toDisplayString(item.Label), 1)
                                              ]),
                                              _: 2
                                            }, 1032, ["modelValue", "onUpdate:modelValue", "fetch-suggestions", "onSelect"]))
                                          : (model.Where.Prop == 'DynamicSearch_MakeUserId')
                                            ? (_openBlock(), _createBlock(_component_miezz_select, {
                                                key: 24,
                                                modelValue: model.Where.Value,
                                                "onUpdate:modelValue": ($event: any) => ((model.Where.Value) = $event),
                                                options: _ctx.makers,
                                                clearable: ""
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "options"]))
                                            : _createCommentVNode("", true)
        ]),
        defaultTip: _withCtx(() => [
          _createElementVNode("div", _hoisted_91, [
            _createElementVNode("span", {
              style: {"color":"#f56c6c","font-size":"14px","cursor":"pointer","font-weight":"900","padding-left":"5px","padding-right":"10px"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onStatTip()))
            }, "统计结果"),
            _createElementVNode("span", {
              style: {"color":"#f56c6c","font-size":"14px","cursor":"pointer","font-weight":"900","padding-left":"5px"},
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onTik()))
            }, "提示")
          ])
        ]),
        default: _withCtx(() => [
          (!_ctx.write)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                type: "selection",
                width: "45",
                selectable: _ctx.handleSelectable
              }, null, 8, ["selectable"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "onHandleSelect", "onHandleTopButtonClick", "onHandleRowButtonClick", "onHandleBottomButtonClick"]),
      _createVNode(_component_miezz_modal, {
        modelValue: _ctx.modalDetail,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalDetail) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bill_detail, {
            modelValue: _ctx.modalDetail,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalDetail) = $event)),
            id: _ctx.id,
            onHandleSubmit: _ctx.handleSubmit,
            onHandleDelete: _ctx.handleDelete
          }, null, 8, ["modelValue", "id", "onHandleSubmit", "onHandleDelete"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_miezz_modal, {
        modelValue: _ctx.modalForm,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.modalForm) = $event))
      }, {
        default: _withCtx(() => [
          _createVNode(_component_bill_form, {
            modelValue: _ctx.modalForm,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.modalForm) = $event)),
            id: _ctx.id,
            type: _ctx.type,
            onHandleSubmit: _ctx.handleSubmit
          }, null, 8, ["modelValue", "id", "type", "onHandleSubmit"])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.invoiceForm != undefined)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 0,
            modelValue: _ctx.invoiceForm.Visiable,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.invoiceForm.Visiable) = $event)),
            "show-close": false,
            style: {"width":"100%"},
            top: "0px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": true
          }, {
            header: _withCtx(({ close }) => [
              _hoisted_92,
              _createElementVNode("div", _hoisted_93, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_el_form, {
                  ref: "refInvoiceForm",
                  model: _ctx.invoiceForm,
                  rules: _ctx.rules
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_94, [
                      _createElementVNode("div", _hoisted_95, [
                        _hoisted_96,
                        _createElementVNode("span", _hoisted_97, _toDisplayString(_ctx.invoiceForm.BillString), 1)
                      ]),
                      _createElementVNode("div", _hoisted_98, [
                        _hoisted_99,
                        _createElementVNode("span", _hoisted_100, [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.invoiceForm.Status,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.invoiceForm.Status) = $event)),
                            filterable: "",
                            placeholder: "请选择",
                            disabled: 
                    _ctx.invoiceForm.InvoiceItems == null ||
                    _ctx.invoiceForm.InvoiceItems == undefined ||
                    _ctx.invoiceForm.InvoiceItems.length <= 0
                      ? true
                      : false
                  
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EnumInvoiceStatusOption, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.Value,
                                  label: item.Label,
                                  disabled: item.disabled,
                                  value: item.Value
                                }, null, 8, ["label", "disabled", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_101, [
                        _hoisted_102,
                        _createElementVNode("span", _hoisted_103, _toDisplayString(_ctx.invoiceForm.InvoiceString), 1)
                      ]),
                      _createElementVNode("div", _hoisted_104, [
                        _hoisted_105,
                        _createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.invoiceForm.SettlementString), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_107, [
                      (_ctx.IsBillSame != true)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_108, " 账单合计金额与发票换算合计金额不一致 "))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_el_table, {
                      ref: "invoiceTable",
                      border: "",
                      script: "",
                      data: _ctx.invoiceForm.InvoiceItems
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "Number",
                          width: "220",
                          label: "发票号码"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_109,
                            _createElementVNode("div", _hoisted_110, [
                              _createVNode(_component_miezz_text_ellipsis, {
                                text: '发票号码',
                                tooltip: true
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_111, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                rules: _ctx.rules.Number,
                                prop: 'InvoiceItems.' + scope.$index + '.Number'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    placeholder: "请填写",
                                    style: {"width":"100% !important"},
                                    modelValue: scope.row.Number,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Number) = $event),
                                    onChange: ($event: any) => (_ctx.onChangeInvoiceNumber(scope.row))
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "CollectionTitle",
                          label: ""
                        }, {
                          header: _withCtx(() => [
                            _hoisted_112,
                            _createElementVNode("div", _hoisted_113, [
                              _createVNode(_component_miezz_text_ellipsis, {
                                text: '收款方发票抬头',
                                tooltip: true
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_114, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                prop: 'InvoiceItems.' + scope.$index + '.CollectionTitle',
                                rules: [
                      {
                        required: true,
                        message: '信息不能为空',
                        trigger: 'blur',
                      },
                    ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    placeholder: "请填写",
                                    disabled: 
                        scope.row.Number == null ||
                        scope.row.Number == undefined ||
                        scope.row.Number == ''
                          ? true
                          : false
                      ,
                                    modelValue: scope.row.CollectionTitle,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.CollectionTitle) = $event)
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "PaymentTitle",
                          label: "付款方发票抬头"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_115,
                            _createElementVNode("div", _hoisted_116, [
                              _createVNode(_component_miezz_text_ellipsis, {
                                text: '付款方发票抬头',
                                tooltip: true
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_117, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                prop: 'InvoiceItems.' + scope.$index + '.PaymentTitle',
                                rules: [
                      {
                        required: true,
                        message: '信息不能为空',
                        trigger: 'blur',
                      },
                    ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    placeholder: "请填写",
                                    disabled: 
                        scope.row.Number == null ||
                        scope.row.Number == undefined ||
                        scope.row.Number == ''
                          ? true
                          : false
                      ,
                                    modelValue: scope.row.PaymentTitle,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.PaymentTitle) = $event)
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "CurrencySystemId",
                          width: "140",
                          label: "币制"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_118,
                            _createElementVNode("div", _hoisted_119, [
                              _createVNode(_component_miezz_text_ellipsis, {
                                text: '币制',
                                tooltip: true
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_120, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                prop: 'InvoiceItems.' + scope.$index + '.CurrencySystemId',
                                rules: [
                      {
                        required: true,
                        message: '信息不能为空',
                        trigger: 'blur',
                      },
                    ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: scope.row.CurrencySystemId,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.CurrencySystemId) = $event),
                                    filterable: "",
                                    placeholder: "请选择",
                                    "allow-create": "",
                                    onChange: ($event: any) => (_ctx.onChangeInvoicePrice(scope.$index, 1))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencys, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.Value,
                                          label: item.Label,
                                          value: item.Value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                ]),
                                _: 2
                              }, 1032, ["prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Price",
                          width: "140",
                          label: "金额"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_121,
                            _createElementVNode("div", _hoisted_122, [
                              _createVNode(_component_miezz_text_ellipsis, {
                                text: '金额',
                                tooltip: true
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_123, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                prop: 'InvoiceItems.' + scope.$index + '.Price',
                                rules: [
                      {
                        required: true,
                        message: '信息不能为空',
                        trigger: 'blur',
                      },
                    ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    placeholder: "请填写",
                                    onBlur: ($event: any) => (_ctx.onChangeInvoicePrice(scope.$index, 0)),
                                    disabled: 
                        scope.row.Number == null ||
                        scope.row.Number == undefined ||
                        scope.row.Number == ''
                          ? true
                          : false
                      ,
                                    modelValue: scope.row.Price,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Price) = $event),
                                    number: true,
                                    pattern: "[-0-9.,]"
                                  }, null, 8, ["onBlur", "disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "InvoiceDate",
                          width: "140",
                          label: "开票日期"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_124, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: scope.row.InvoiceDate,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.InvoiceDate) = $event),
                                    placeholder: "请选择",
                                    format: "YYYY/MM/DD"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Annexs",
                          width: "70",
                          label: "凭证"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_125, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  (
                        _ctx.FinancialManagement_BillSummary_InvoiceInformation ==
                          false
                      )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_126, [
                                        (
                          scope.row.Annexs != null &&
                          scope.row.Annexs != undefined &&
                          scope.row.Annexs.length > 0
                        )
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_127, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.Annexs, (p, index) => {
                                                return (_openBlock(), _createBlock(_component_miezz_thumbnail, {
                                                  modelValue: p.Url,
                                                  "onUpdate:modelValue": ($event: any) => ((p.Url) = $event),
                                                  key: index,
                                                  type: 'file',
                                                  icon: 'DocumentDelete'
                                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_128, [
                                              _createVNode(_component_miezz_thumbnail, {
                                                modelValue: undefined,
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((undefined) = $event)),
                                                type: 'image',
                                                icon: 'DocumentDelete'
                                              })
                                            ]))
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_129, [
                                        _createVNode(_component_miezz_upload, {
                                          isSingle: true,
                                          isTip: false,
                                          modelValue: scope.row.Annexs,
                                          "onUpdate:modelValue": ($event: any) => ((scope.row.Annexs) = $event),
                                          path: "bill/invoice",
                                          accept: "file/*",
                                          prop: "Url",
                                          maxSize: 5 * 1024 * 1024
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_CloseBold)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 2
                                        }, 1032, ["modelValue", "onUpdate:modelValue"])
                                      ]))
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementCurrencySystemId",
                          width: "140",
                          label: "换算币制",
                          style: {"display":"none"}
                        }, {
                          header: _withCtx(() => [
                            _hoisted_130,
                            _createElementVNode("div", _hoisted_131, [
                              _createVNode(_component_miezz_text_ellipsis, {
                                text: '换算币制',
                                tooltip: true
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_132, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                prop: 
                      'InvoiceItems.' +
                      scope.$index +
                      '.SettlementCurrencySystemId'
                    ,
                                rules: [
                      {
                        required: true,
                        message: '信息不能为空',
                        trigger: 'blur',
                      },
                    ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: scope.row.SettlementCurrencySystemId,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.SettlementCurrencySystemId) = $event),
                                    filterable: "",
                                    placeholder: "请选择",
                                    "allow-create": "",
                                    onChange: ($event: any) => (_ctx.onChangeInvoicePrice(scope.$index, 2))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencys, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.Value,
                                          label: item.Label,
                                          value: item.Value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                ]),
                                _: 2
                              }, 1032, ["prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementRate",
                          label: "汇率"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_133,
                            _createElementVNode("div", _hoisted_134, [
                              _createVNode(_component_miezz_text_ellipsis, {
                                text: '汇率',
                                tooltip: true
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_135, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                prop: 'InvoiceItems.' + scope.$index + '.SettlementRate',
                                rules: [
                      {
                        required: true,
                        message: '信息不能为空',
                        trigger: 'blur',
                      },
                    ]
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    placeholder: "请填写",
                                    disabled: 
                        scope.row.Number == null ||
                        scope.row.Number == undefined ||
                        scope.row.Number == ''
                          ? true
                          : scope.row.CurrencySystemId ==
                            scope.row.SettlementCurrencySystemId
                          ? true
                          : false
                      ,
                                    modelValue: scope.row.SettlementRate,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.SettlementRate) = $event),
                                    onChange: ($event: any) => (_ctx.onChangeInvoiceSettlementRate(scope.$index))
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
                                ]),
                                _: 2
                              }, 1032, ["prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementPrice",
                          label: "换算金额"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_136, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    placeholder: "请填写",
                                    disabled: true,
                                    modelValue: scope.row.SettlementPrice,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.SettlementPrice) = $event),
                                    number: true,
                                    pattern: "[-0-9.,]"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementStatus",
                          label: "到账状态"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_137, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: scope.row.SettlementStatus,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.SettlementStatus) = $event),
                                    disabled: 
                        scope.row.Number == null ||
                        scope.row.Number == undefined ||
                        scope.row.Number == ''
                          ? true
                          : false
                      ,
                                    filterable: "",
                                    placeholder: "请选择"
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.EnumInvoiceSettlementStatusOption, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.Value,
                                          label: item.Label,
                                          disabled: item.disabled,
                                          value: item.Value
                                        }, null, 8, ["label", "disabled", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "disabled"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Remark",
                          label: "备注"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_138, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    placeholder: "请填写",
                                    disabled: 
                        scope.row.Number == null ||
                        scope.row.Number == undefined ||
                        scope.row.Number == ''
                          ? true
                          : false
                      ,
                                    modelValue: scope.row.Remark,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Remark) = $event)
                                  }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        (_ctx.FinancialManagement_BillSummary_InvoiceInformation == true)
                          ? (_openBlock(), _createBlock(_component_el_table_column, {
                              key: 0,
                              label: "操作",
                              width: "60"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", {
                                  style: {"cursor":"pointer"},
                                  onClick: ($event: any) => (_ctx.onDeleteInvoice(scope.$index)),
                                  title: "删除"
                                }, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Delete)
                                    ]),
                                    _: 1
                                  })
                                ], 8, _hoisted_139)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["data"]),
                    (_ctx.FinancialManagement_BillSummary_InvoiceInformation == true)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_140, [
                          _createElementVNode("span", {
                            style: {"cursor":"pointer"},
                            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onAddInvoice && _ctx.onAddInvoice(...args)))
                          }, [
                            _createVNode(_component_el_icon, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_Plus)
                              ]),
                              _: 1
                            }),
                            _createTextVNode(" 添加")
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_miezz_upload, {
                      modelValue: _ctx.invoiceForm.Files,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.invoiceForm.Files) = $event)),
                      path: "order/bill/file",
                      prop: "File",
                      maxSize: 2 * 1024 * 1024
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _hoisted_141,
              _createElementVNode("div", _hoisted_142, [
                _createVNode(_component_miezz_button_bar, {
                  modelValue: _ctx.invoiceBottomButtons,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.invoiceBottomButtons) = $event)),
                  isBackground: true,
                  onHandleClick: _ctx.handleClickInvoice
                }, null, 8, ["modelValue", "onHandleClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.settlementForm != undefined)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 1,
            modelValue: _ctx.settlementForm.Visiable,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.settlementForm.Visiable) = $event)),
            "show-close": false,
            style: {"width":"90%"},
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "0px",
            "append-to-body": true
          }, {
            header: _withCtx(({ close }) => [
              _hoisted_143,
              _createElementVNode("div", _hoisted_144, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_145, [
                _createVNode(_component_el_card, { style: {"margin-top":"5px"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form, {
                      ref: "refSettlementForm",
                      model: _ctx.settlementForm,
                      rules: _ctx.settlementRules
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "总金额",
                          style: {"margin-top":"0px"},
                          "label-width": "100px"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.settlementForm.CurrencySystemCode) + _toDisplayString(_ctx.formatNumber(_ctx.settlementForm.Total)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "待核销",
                          style: {"margin-top":"-10px"},
                          "label-width": "100px"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.settlementForm.CurrencySystemCode) + _toDisplayString(_ctx.formatNumber(_ctx.settlementForm.NoSettlementPrice)) + " ", 1),
                            (
                  _ctx.settlementForm.NoSettlementPrice != 0 &&
                  _ctx.FinancialManagement_BillSummary_BadDebtWriteOff == true
                )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_146, [
                                  _createElementVNode("span", {
                                    style: {"cursor":"pointer"},
                                    onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onAddBadSettlement && _ctx.onAddBadSettlement(...args)))
                                  }, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Plus)
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" 坏账")
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          label: "已核销",
                          style: {"margin-top":"-10px"},
                          "label-width": "100px"
                        }, {
                          default: _withCtx(() => [
                            (
                  _ctx.settlementForm.SettlementPrice != null &&
                  _ctx.settlementForm.SettlementPrice != undefined &&
                  _ctx.settlementForm.SettlementPrice != ''
                )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_147, _toDisplayString(_ctx.formatNumber(_ctx.settlementForm.SettlementPrice)), 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_148, "CNY0")),
                            (
                  _ctx.settlementForm.NoSettlementPrice != 0 &&
                  _ctx.FinancialManagement_BillSummary_Writeoff == true
                )
                              ? (_openBlock(), _createElementBlock("span", _hoisted_149, [
                                  _createElementVNode("span", {
                                    style: {"cursor":"pointer"},
                                    onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onAddSettlement && _ctx.onAddSettlement(...args)))
                                  }, [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Plus)
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" 添加")
                                  ])
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }),
                        (_openBlock(), _createBlock(_component_el_table, {
                          ref: "settlementTable",
                          key: _ctx.settlementTableRandom,
                          data: _ctx.settlementForm.Items
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_table_column, {
                              prop: "Price",
                              "show-overflow-tooltip": true,
                              label: "核销金额"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_150, _toDisplayString(scope.row.CurrencySystem.Code) + _toDisplayString(_ctx.formatNumber(scope.row.Price)), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "DisplayRate",
                              width: "90px",
                              "show-overflow-tooltip": true,
                              label: "汇率"
                            }, {
                              default: _withCtx((scope) => [
                                (scope.row.IsBad != true)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_151, [
                                      (
                        scope.row.DisplayRate != null &&
                        scope.row.DisplayRate != undefined &&
                        scope.row.DisplayRate != ''
                      )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_152, _toDisplayString(scope.row.DisplayRate), 1))
                                        : (_openBlock(), _createElementBlock("div", _hoisted_153, " 1 "))
                                    ]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_154, " — "))
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "SettlementDateString",
                              "show-overflow-tooltip": true,
                              label: "核销时间"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_155, _toDisplayString(scope.row.SettlementDateString), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "CollectionTitle",
                              "show-overflow-tooltip": true,
                              label: "收款方"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_156, [
                                  (scope.row.IsBad != true)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_157, _toDisplayString(scope.row.CollectionTitle), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_158, " — "))
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "PaymentTitle",
                              "show-overflow-tooltip": true,
                              label: "付款方"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_159, [
                                  (scope.row.IsBad != true)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_160, _toDisplayString(scope.row.PaymentTitle), 1))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_161, " — "))
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Mode",
                              "show-overflow-tooltip": true,
                              label: "核销方式"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_162, [
                                  (scope.row.IsBad != true)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_163, [
                                        (scope.row.Mode == 10)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_164, "对公银行"))
                                          : (_openBlock(), _createElementBlock("span", _hoisted_165, "现金/私人银行/其他"))
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_166, " 坏账核销 "))
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "Remark",
                              "show-overflow-tooltip": true,
                              label: "备注"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_167, _toDisplayString(scope.row.Remark), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "SettlementAnnexs",
                              "show-overflow-tooltip": true,
                              label: "凭证"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_168, [
                                  _createVNode(_component_miezz_upload, {
                                    isTip: false,
                                    multiple: true,
                                    preview: true,
                                    modelValue: scope.row.SettlementAnnexs,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.SettlementAnnexs) = $event),
                                    path: "bill/file",
                                    accept: "file/*",
                                    prop: "Url",
                                    maxSize: 5 * 1024 * 1024
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_table_column, {
                              prop: "CreatedUserName",
                              "show-overflow-tooltip": true,
                              label: "创建人"
                            }, {
                              default: _withCtx((scope) => [
                                _createElementVNode("div", _hoisted_169, _toDisplayString(scope.row.CreatedUserName), 1)
                              ]),
                              _: 1
                            }),
                            (
                  _ctx.FinancialManagement_BillSummary_Writeoff == true ||
                  _ctx.FinancialManagement_BillSummary_BadDebtWriteOff == true
                )
                              ? (_openBlock(), _createBlock(_component_el_table_column, {
                                  key: 0,
                                  label: "操作",
                                  width: "100"
                                }, {
                                  default: _withCtx((scope) => [
                                    (
                      scope.row.IsBad != true &&
                      _ctx.FinancialManagement_BillSummary_Writeoff == true
                    )
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          style: {"cursor":"pointer"},
                                          onClick: ($event: any) => (_ctx.onEditSettlement(scope.row)),
                                          title: "编辑"
                                        }, [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Edit)
                                            ]),
                                            _: 1
                                          })
                                        ], 8, _hoisted_170))
                                      : (
                      _ctx.FinancialManagement_BillSummary_BadDebtWriteOff == true
                    )
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 1,
                                            style: {"cursor":"pointer"},
                                            onClick: ($event: any) => (_ctx.onEditBadSettlement(scope.row)),
                                            title: "编辑"
                                          }, [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Edit)
                                              ]),
                                              _: 1
                                            })
                                          ], 8, _hoisted_171))
                                        : _createCommentVNode("", true),
                                    (
                      scope.row.IsBad != true &&
                      _ctx.FinancialManagement_BillSummary_Writeoff == true
                    )
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 2,
                                          style: {"cursor":"pointer","margin-left":"10px"},
                                          onClick: ($event: any) => (_ctx.onDeleteSettlement(scope.$index)),
                                          title: "删除"
                                        }, [
                                          _createVNode(_component_el_icon, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_Delete)
                                            ]),
                                            _: 1
                                          })
                                        ], 8, _hoisted_172))
                                      : (
                      _ctx.FinancialManagement_BillSummary_BadDebtWriteOff == true
                    )
                                        ? (_openBlock(), _createElementBlock("span", {
                                            key: 3,
                                            style: {"cursor":"pointer","margin-left":"10px"},
                                            onClick: ($event: any) => (_ctx.onDeleteSettlement(scope.$index)),
                                            title: "删除"
                                          }, [
                                            _createVNode(_component_el_icon, null, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_Delete)
                                              ]),
                                              _: 1
                                            })
                                          ], 8, _hoisted_173))
                                        : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 8, ["data"]))
                      ]),
                      _: 1
                    }, 8, ["model", "rules"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_card, { style: {"margin-top":"5px","display":"none"} }, {
                  header: _withCtx(() => [
                    _createElementVNode("div", {
                      style: {"width":"100% !important","cursor":"pointer","height":"50px","line-height":"50px"},
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.isHistory = !_ctx.isHistory))
                    }, [
                      _hoisted_174,
                      _createElementVNode("div", _hoisted_175, [
                        (_ctx.isHistory == false)
                          ? (_openBlock(), _createBlock(_component_el_icon, { key: 0 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ArrowDownBold)
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_el_icon, { key: 1 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ArrowUpBold)
                              ]),
                              _: 1
                            }))
                      ])
                    ]),
                    (_ctx.isHistory == false)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_176, [
                          (
                  _ctx.historys.Data.Items != null &&
                  _ctx.historys.Data.Items != undefined &&
                  _ctx.historys.Data.Items.length > 0
                )
                            ? (_openBlock(), _createBlock(_component_el_timeline, { key: 0 }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historys.Data.Items, (activity, index) => {
                                    return (_openBlock(), _createBlock(_component_el_timeline_item, {
                                      key: index,
                                      timestamp: activity.CreatedTime,
                                      "hide-timestamp": true
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_177, [
                                          _createElementVNode("div", {
                                            style: {"cursor":"pointer"},
                                            onClick: ($event: any) => (activity.IsOpen = !activity.IsOpen)
                                          }, [
                                            _createElementVNode("div", _hoisted_179, [
                                              _createTextVNode(_toDisplayString(activity.CreatedTime) + " 由", 1),
                                              _createElementVNode("span", _hoisted_180, _toDisplayString(activity.CreatedUserName) + "（" + _toDisplayString(activity.CreatedCompanyNameZh) + "）", 1),
                                              _createTextVNode(_toDisplayString(activity.Title), 1),
                                              (
                            activity.NewLabel != null &&
                            activity.NewLabel != undefined &&
                            activity.NewLabel != ''
                          )
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_181, "（" + _toDisplayString(activity.NewLabel) + "）", 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            (
                          activity.IsOpen == false &&
                          activity.Child != null &&
                          activity.Child != undefined &&
                          activity.Child.length > 0
                        )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_182, [
                                                  _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Plus)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : _createCommentVNode("", true),
                                            (
                          activity.IsOpen == true &&
                          activity.Child != null &&
                          activity.Child != undefined &&
                          activity.Child.length > 0
                        )
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_183, [
                                                  _createVNode(_component_el_icon, null, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_Minus)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]))
                                              : _createCommentVNode("", true),
                                            _hoisted_184
                                          ], 8, _hoisted_178),
                                          (
                        activity.Child != null &&
                        activity.Child != undefined &&
                        activity.Child.length > 0 &&
                        activity.IsOpen == true
                      )
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_185, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activity.Child, (p, index1) => {
                                                  return (_openBlock(), _createElementBlock("div", { key: index1 }, [
                                                    (
                            p.Title != null &&
                            p.Title != undefined &&
                            p.Title != ''
                          )
                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_186, [
                                                          (
                              p.Child != null &&
                              p.Child != undefined &&
                              p.Child.length > 0
                            )
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_187, _toDisplayString(p.Title), 1))
                                                            : _createCommentVNode("", true),
                                                          (
                              p.Child != null &&
                              p.Child != undefined &&
                              p.Child.length > 0
                            )
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_188, [
                                                                (
                                p.Child != null &&
                                p.Child != undefined &&
                                p.Child.length > 0
                              )
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_189, [
                                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p2, index2) => {
                                                                        return (_openBlock(), _createElementBlock("div", { key: index2 }, [
                                                                          (
                                    p2.Child == null ||
                                    p2.Child == undefined ||
                                    p2.Child.length <= 0
                                  )
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_190, [
                                                                                (
                                      p2.State == 4 &&
                                      (index2 == 0 || p.IsOpen == true)
                                    )
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_191, [
                                                                                      _createTextVNode(" 新增了"),
                                                                                      _createElementVNode("span", _hoisted_192, _toDisplayString(p2.Label), 1),
                                                                                      _createTextVNode("，新值为\"" + _toDisplayString(p2.NewLabel) + "\" ", 1)
                                                                                    ]))
                                                                                  : _createCommentVNode("", true),
                                                                                (
                                      p2.State == 3 &&
                                      (index2 == 0 || p.IsOpen == true)
                                    )
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_193, [
                                                                                      _createTextVNode(" 编辑了"),
                                                                                      _createElementVNode("span", _hoisted_194, _toDisplayString(p2.Label), 1),
                                                                                      _createTextVNode("，由\"" + _toDisplayString(p2.OldLabel) + "\"改为\"" + _toDisplayString(p2.NewLabel) + "\" ", 1)
                                                                                    ]))
                                                                                  : _createCommentVNode("", true),
                                                                                (
                                      p2.State == 2 &&
                                      (index2 == 0 || p.IsOpen == true)
                                    )
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_195, [
                                                                                      _createTextVNode(" 删除了"),
                                                                                      _createElementVNode("span", _hoisted_196, _toDisplayString(p2.Label), 1),
                                                                                      _createTextVNode("，原值为\"" + _toDisplayString(p2.NewLabel) + "\" ", 1)
                                                                                    ]))
                                                                                  : _createCommentVNode("", true),
                                                                                (
                                      p2.State == 999 &&
                                      (index2 == 0 || p.IsOpen == true)
                                    )
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_197, [
                                                                                      _createElementVNode("span", _hoisted_198, "未编辑" + _toDisplayString(p2.Label), 1),
                                                                                      _createTextVNode("，原值为\"" + _toDisplayString(p2.OldLabel) + "\" ", 1)
                                                                                    ]))
                                                                                  : _createCommentVNode("", true),
                                                                                (p.IsOpen == false && index2 == 0)
                                                                                  ? (_openBlock(), _createElementBlock("div", {
                                                                                      key: 4,
                                                                                      onClick: ($event: any) => (p.IsOpen = !p.IsOpen),
                                                                                      style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                    }, [
                                                                                      _createVNode(_component_el_icon, null, {
                                                                                        default: _withCtx(() => [
                                                                                          _createVNode(_component_Plus)
                                                                                        ]),
                                                                                        _: 1
                                                                                      })
                                                                                    ], 8, _hoisted_199))
                                                                                  : _createCommentVNode("", true),
                                                                                (p.IsOpen == true && index2 == 0)
                                                                                  ? (_openBlock(), _createElementBlock("div", {
                                                                                      key: 5,
                                                                                      onClick: ($event: any) => (p.IsOpen = !p.IsOpen),
                                                                                      style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                    }, [
                                                                                      _createVNode(_component_el_icon, null, {
                                                                                        default: _withCtx(() => [
                                                                                          _createVNode(_component_Minus)
                                                                                        ]),
                                                                                        _: 1
                                                                                      })
                                                                                    ], 8, _hoisted_200))
                                                                                  : _createCommentVNode("", true),
                                                                                _hoisted_201
                                                                              ]))
                                                                            : (_openBlock(), _createElementBlock("div", _hoisted_202, [
                                                                                (
                                      p2.Title != null &&
                                      p2.Title != undefined &&
                                      p2.Title != ''
                                    )
                                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_203, _toDisplayString(p2.Title), 1))
                                                                                  : (_openBlock(), _createElementBlock("div", _hoisted_204, _toDisplayString(p2.NewLabel), 1))
                                                                              ])),
                                                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p2.Child, (p3, index3) => {
                                                                            return (_openBlock(), _createElementBlock("div", {
                                                                              key: index3,
                                                                              style: {"line-height":"28px"}
                                                                            }, [
                                                                              (
                                      p3.State == 4 &&
                                      (index3 == 0 || p2.IsOpen == true)
                                    )
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_205, [
                                                                                    _createTextVNode(" 新增了"),
                                                                                    _createElementVNode("span", _hoisted_206, _toDisplayString(p3.Label), 1),
                                                                                    _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\" ", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (
                                      p3.State == 3 &&
                                      (index3 == 0 || p2.IsOpen == true)
                                    )
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_207, [
                                                                                    _createTextVNode(" 编辑了"),
                                                                                    _createElementVNode("span", _hoisted_208, _toDisplayString(p3.Label), 1),
                                                                                    _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\" ", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (
                                      p3.State == 2 &&
                                      (index3 == 0 || p2.IsOpen == true)
                                    )
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_209, [
                                                                                    _createTextVNode(" 删除了"),
                                                                                    _createElementVNode("span", _hoisted_210, _toDisplayString(p3.Label), 1),
                                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\" ", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (
                                      p3.State == 999 &&
                                      (index3 == 0 || p2.IsOpen == true)
                                    )
                                                                                ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                                                                                    _createElementVNode("span", _hoisted_212, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                                    _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\" ", 1)
                                                                                  ]))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.IsOpen == false && index3 == 0)
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 4,
                                                                                    onClick: ($event: any) => (p2.IsOpen = !p2.IsOpen),
                                                                                    style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                  }, [
                                                                                    _createVNode(_component_el_icon, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_Plus)
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ], 8, _hoisted_213))
                                                                                : _createCommentVNode("", true),
                                                                              (p2.IsOpen == true && index3 == 0)
                                                                                ? (_openBlock(), _createElementBlock("div", {
                                                                                    key: 5,
                                                                                    onClick: ($event: any) => (p2.IsOpen = !p2.IsOpen),
                                                                                    style: {"margin-top":"5px","margin-left":"5px","cursor":"pointer","font-size":"10px","border":"1px solid #aaa","height":"16px","width":"16px","float":"left","text-align":"center","line-height":"16px"}
                                                                                  }, [
                                                                                    _createVNode(_component_el_icon, null, {
                                                                                      default: _withCtx(() => [
                                                                                        _createVNode(_component_Minus)
                                                                                      ]),
                                                                                      _: 1
                                                                                    })
                                                                                  ], 8, _hoisted_214))
                                                                                : _createCommentVNode("", true),
                                                                              _hoisted_215
                                                                            ]))
                                                                          }), 128))
                                                                        ]))
                                                                      }), 128))
                                                                    ]))
                                                                  : (_openBlock(), _createElementBlock("div", _hoisted_216, "—"))
                                                              ]))
                                                            : _createCommentVNode("", true),
                                                          _hoisted_217
                                                        ]))
                                                      : (_openBlock(), _createElementBlock("div", _hoisted_218, [
                                                          (
                              p.Child == null ||
                              p.Child == undefined ||
                              p.Child.length <= 0
                            )
                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_219, [
                                                                (p.State == 4)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_220, [
                                                                      _createTextVNode(" 新增了"),
                                                                      _createElementVNode("span", _hoisted_221, _toDisplayString(p.Label), 1),
                                                                      _createTextVNode("，新值为\"" + _toDisplayString(p.NewLabel) + "\" ", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (p.State == 3)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_222, [
                                                                      _createTextVNode(" 编辑了"),
                                                                      _createElementVNode("span", _hoisted_223, _toDisplayString(p.Label), 1),
                                                                      _createTextVNode("，由\"" + _toDisplayString(p.OldLabel) + "\"改为\"" + _toDisplayString(p.NewLabel) + "\" ", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (p.State == 2)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_224, [
                                                                      _createTextVNode(" 删除了"),
                                                                      _createElementVNode("span", _hoisted_225, _toDisplayString(p.Label), 1),
                                                                      _createTextVNode("，原值为\"" + _toDisplayString(p.NewLabel) + "\" ", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true),
                                                                (p.State == 999)
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_226, [
                                                                      _createElementVNode("span", _hoisted_227, "未编辑" + _toDisplayString(p.Label), 1),
                                                                      _createTextVNode("，原值为\"" + _toDisplayString(p.OldLabel) + "\" ", 1)
                                                                    ]))
                                                                  : _createCommentVNode("", true)
                                                              ]))
                                                            : (_openBlock(), _createElementBlock("div", _hoisted_228, [
                                                                (
                                p.Title != null &&
                                p.Title != undefined &&
                                p.Title != ''
                              )
                                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_229, _toDisplayString(p.Title), 1))
                                                                  : (_openBlock(), _createElementBlock("div", _hoisted_230, _toDisplayString(p.NewLabel), 1)),
                                                                _createElementVNode("div", _hoisted_231, [
                                                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.Child, (p3, index3) => {
                                                                    return (_openBlock(), _createElementBlock("div", {
                                                                      style: {"clear":"both"},
                                                                      key: index3
                                                                    }, [
                                                                      (p3.State == 4)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_232, [
                                                                            _createTextVNode(" 新增了"),
                                                                            _createElementVNode("span", _hoisted_233, _toDisplayString(p3.Label), 1),
                                                                            _createTextVNode("，新值为\"" + _toDisplayString(p3.NewLabel) + "\" ", 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (p3.State == 3)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_234, [
                                                                            _createTextVNode(" 编辑了"),
                                                                            _createElementVNode("span", _hoisted_235, _toDisplayString(p3.Label), 1),
                                                                            _createTextVNode("，由\"" + _toDisplayString(p3.OldLabel) + "\"改为\"" + _toDisplayString(p3.NewLabel) + "\" ", 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (p3.State == 2)
                                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_236, [
                                                                            _createTextVNode(" 删除了"),
                                                                            _createElementVNode("span", _hoisted_237, _toDisplayString(p3.Label), 1),
                                                                            _createTextVNode("，原值为\"" + _toDisplayString(p3.NewLabel) + "\" ", 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true),
                                                                      (p3.State == 999)
                                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_238, [
                                                                            _createElementVNode("span", _hoisted_239, "未编辑" + _toDisplayString(p3.Label), 1),
                                                                            _createTextVNode("，原值为\"" + _toDisplayString(p3.OldLabel) + "\"", 1)
                                                                          ]))
                                                                        : _createCommentVNode("", true)
                                                                    ]))
                                                                  }), 128)),
                                                                  _hoisted_240
                                                                ]),
                                                                _hoisted_241
                                                              ]))
                                                        ]))
                                                  ]))
                                                }), 128))
                                              ]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1032, ["timestamp"]))
                                  }), 128))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createElementBlock("div", _hoisted_242, " 暂无数据 "))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _hoisted_243,
              _createElementVNode("div", _hoisted_244, [
                _createVNode(_component_miezz_button_bar, {
                  modelValue: _ctx.settlementBottomButtons,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.settlementBottomButtons) = $event)),
                  isBackground: true,
                  onHandleClick: _ctx.handleClickSettlement
                }, null, 8, ["modelValue", "onHandleClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.oneSettlementForm != undefined)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 2,
            modelValue: _ctx.oneSettlementForm.Visiable,
            "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.oneSettlementForm.Visiable) = $event)),
            "show-close": false,
            style: {"width":"50%"},
            top: "20px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": true
          }, {
            header: _withCtx(({ close }) => [
              _hoisted_245,
              _createElementVNode("div", _hoisted_246, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_247, [
                _createVNode(_component_el_form, {
                  ref: "refOneSettlementForm",
                  model: _ctx.oneSettlementForm,
                  rules: _ctx.oneSettlementRules,
                  "label-width": "120px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "待核销",
                      style: {"margin-top":"0px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.oneSettlementForm.BillCurrencySystemCode) + _toDisplayString(_ctx.formatNumber(_ctx.oneSettlementForm.NoSettlementPrice)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "剩余",
                      style: _normalizeStyle([{"margin-top":"-10px"}, _ctx.oneSettlementForm.SurplusPrice != 0 ? 'color:red' : ''])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.oneSettlementForm.BillCurrencySystemCode) + _toDisplayString(_ctx.formatNumber(_ctx.oneSettlementForm.SurplusPrice)), 1)
                      ]),
                      _: 1
                    }, 8, ["style"]),
                    _createVNode(_component_el_form_item, {
                      label: "折算后",
                      style: {"margin-top":"-10px","display":"none"},
                      "label-width": "100px"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.oneSettlementForm.BillCurrencySystemCode) + _toDisplayString(_ctx.formatNumber(_ctx.oneSettlementForm.ConvertPrice)), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "核销币制",
                      prop: "CurrencySystemId"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          style: {"display":"none"},
                          modelValue: _ctx.oneSettlementForm.CurrencySystemId,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.oneSettlementForm.CurrencySystemId) = $event))
                        }, null, 8, ["modelValue"]),
                        _createElementVNode("div", {
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onCurrency(_ctx.oneSettlementForm.CurrencySystemId))),
                          style: {"width":"100%","word-break":"break-all","text-align":"left","cursor":"pointer","color":"#fe995b"}
                        }, _toDisplayString(_ctx.isString(_ctx.oneSettlementForm.CurrencySystem.Code)), 1)
                      ]),
                      _: 1
                    }),
                    (
              _ctx.oneSettlementForm.BillCurrencySystemId !=
              _ctx.oneSettlementForm.CurrencySystemId
            )
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "汇率",
                          prop: "DisplayRate"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: _ctx.oneSettlementForm.DisplayRate,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.oneSettlementForm.DisplayRate) = $event)),
                              onChange: _cache[21] || (_cache[21] = ($event: any) => (_ctx.onChangeRate()))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, {
                      label: "本次核销金额",
                      prop: "Price"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_input, {
                          placeholder: "请填写",
                          disabled: false,
                          onBlur: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onChangePrice())),
                          modelValue: _ctx.oneSettlementForm.Price,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.oneSettlementForm.Price) = $event)),
                          number: true,
                          pattern: "[-0-9.,]"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "时间",
                      prop: "SettlementDate"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.oneSettlementForm.SettlementDate,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.oneSettlementForm.SettlementDate) = $event)),
                          format: "YYYY/MM/DD HH:mm",
                          type: "datetime",
                          style: {"width":"100% !important"},
                          placeholder: "请选择"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "收款方",
                      prop: "CollectionTitle"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.oneSettlementForm.CollectionTitle,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.oneSettlementForm.CollectionTitle) = $event)),
                          filterable: "",
                          placeholder: "请选择",
                          "allow-create": "",
                          clearable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settlementForm.CollectionTitles, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.Value,
                                label: item.Label,
                                value: item.Value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "付款方",
                      prop: "PaymentTitle"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.oneSettlementForm.PaymentTitle,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.oneSettlementForm.PaymentTitle) = $event)),
                          filterable: "",
                          placeholder: "请选择",
                          "allow-create": "",
                          clearable: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.settlementForm.PaymentTitles, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.Value,
                                label: item.Label,
                                value: item.Value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    (_openBlock(), _createBlock(_component_el_form_item, {
                      label: "核销方式",
                      prop: "Mode",
                      key: _ctx.oneSettlementFormMode
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_select, {
                          onChange: _ctx.onChangeOneSettlementMode,
                          modelValue: _ctx.oneSettlementForm.Mode,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.oneSettlementForm.Mode) = $event)),
                          options: _ctx.EnumSettlementModeOption,
                          clearable: false,
                          valueKey: "Value",
                          labelKey: "Label",
                          style: {"width":"100% !important"}
                        }, null, 8, ["onChange", "modelValue", "options"])
                      ]),
                      _: 1
                    })),
                    _createVNode(_component_el_form_item, {
                      label: "备注",
                      prop: "Remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.oneSettlementForm.Remark,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.oneSettlementForm.Remark) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "凭证",
                      prop: "SettlementAnnexs"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_miezz_upload, {
                          modelValue: _ctx.oneSettlementForm.SettlementAnnexs,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.oneSettlementForm.SettlementAnnexs) = $event)),
                          path: "bill/file",
                          prop: "Url",
                          maxSize: 2 * 1024 * 1024
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _hoisted_248,
              _createElementVNode("div", _hoisted_249, [
                _createVNode(_component_miezz_button_bar, {
                  modelValue: _ctx.oneSettlementBottomButtons,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.oneSettlementBottomButtons) = $event)),
                  isBackground: true,
                  onHandleClick: _ctx.handleClickOneSettlement
                }, null, 8, ["modelValue", "onHandleClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.oneBadSettlementForm != undefined)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 3,
            modelValue: _ctx.oneBadSettlementForm.Visiable,
            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.oneBadSettlementForm.Visiable) = $event)),
            "show-close": false,
            style: {"width":"50%"},
            top: "20px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": true
          }, {
            header: _withCtx(({ close }) => [
              _hoisted_250,
              _createElementVNode("div", _hoisted_251, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_252, [
                _createVNode(_component_el_form, {
                  ref: "refOneBadSettlementForm",
                  model: _ctx.oneBadSettlementForm,
                  rules: _ctx.oneSettlementRules,
                  "label-width": "120px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "金额",
                      style: {"margin-top":"0px"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.oneBadSettlementForm.BillCurrencySystemCode) + _toDisplayString(_ctx.oneBadSettlementForm.NoSettlementPrice), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "时间",
                      prop: "SettlementDate"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.oneBadSettlementForm.SettlementDate,
                          "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.oneBadSettlementForm.SettlementDate) = $event)),
                          format: "YYYY/MM/DD HH:mm",
                          type: "datetime",
                          style: {"width":"100% !important"},
                          placeholder: "请选择"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, {
                      label: "备注",
                      prop: "Remark"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.oneBadSettlementForm.Remark,
                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.oneBadSettlementForm.Remark) = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _hoisted_253,
              _createElementVNode("div", _hoisted_254, [
                _createVNode(_component_miezz_button_bar, {
                  modelValue: _ctx.oneBadSettlementBottomButtons,
                  "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.oneBadSettlementBottomButtons) = $event)),
                  isBackground: true,
                  onHandleClick: _ctx.handleClickOneBadSettlement
                }, null, 8, ["modelValue", "onHandleClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.statForm != undefined)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 4,
            modelValue: _ctx.statForm.Visiable,
            "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.statForm.Visiable) = $event)),
            "show-close": false,
            style: {"width":"100%"},
            top: "0px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": true
          }, {
            header: _withCtx(({ close }) => [
              _hoisted_255,
              _createElementVNode("div", _hoisted_256, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", {
                innerHTML: _ctx.statForm.SumString,
                style: {"margin-top":"-20px","margin-left":"0px","padding-left":"0px"}
              }, null, 8, _hoisted_257),
              _createElementVNode("div", _hoisted_258, [
                _createVNode(_component_el_form, {
                  ref: "refStatForm",
                  model: _ctx.statForm
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table, {
                      border: "",
                      script: "",
                      ref: "statTable",
                      "tree-props": { children: 'Child', hasChildren: 'hasChildren' },
                      "row-key": "Id",
                      "default-expand-all": true,
                      data: _ctx.statForm.InvoiceItems
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "Number",
                          width: "220",
                          label: "发票号码"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_259, _toDisplayString(_ctx.isString(scope.row.Number)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "CollectionTitle",
                          label: "收款方发票抬头"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_260, _toDisplayString(_ctx.isString(scope.row.CollectionTitle)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "PaymentTitle",
                          label: "付款方发票抬头"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_261, _toDisplayString(_ctx.isString(scope.row.PaymentTitle)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "CurrencySystemId",
                          width: "140",
                          label: "币制"
                        }, {
                          default: _withCtx((scope) => [
                            (
                    scope.row.CurrencySystem != null &&
                    scope.row.CurrencySystem != undefined
                  )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_262, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code)), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_263, " 暂无数据 "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Price",
                          width: "140",
                          label: "金额"
                        }, {
                          default: _withCtx((scope) => [
                            (scope.row.Price != null && scope.row.Price != undefined)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_264, _toDisplayString(_ctx.isString(_ctx.formatNumber(scope.row.Price))), 1))
                              : (_openBlock(), _createElementBlock("div", _hoisted_265, " 暂无数据 "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "InvoiceDate",
                          width: "140",
                          label: "开票日期"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_266, _toDisplayString(_ctx.isString(scope.row.InvoiceDateString)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Annexs",
                          width: "100",
                          label: "凭证"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_267, [
                              (
                      scope.row.Annexs != null &&
                      scope.row.Annexs != undefined &&
                      scope.row.Annexs.length > 0
                    )
                                ? (_openBlock(), _createElementBlock("span", _hoisted_268, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.Annexs, (p, index) => {
                                      return (_openBlock(), _createElementBlock("span", {
                                        onClick: ($event: any) => (_ctx.onClickFile(p)),
                                        style: {"font-size":"18px","cursor":"pointer"},
                                        key: index
                                      }, [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_Document)
                                          ]),
                                          _: 1
                                        })
                                      ], 8, _hoisted_269))
                                    }), 128))
                                  ]))
                                : (_openBlock(), _createElementBlock("span", _hoisted_270, [
                                    _createVNode(_component_miezz_thumbnail, {
                                      modelValue: undefined,
                                      "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((undefined) = $event)),
                                      type: 'image',
                                      icon: 'DocumentDelete'
                                    })
                                  ]))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementCurrencySystem",
                          label: "换算币制"
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_271, [
                              _createVNode(_component_miezz_text_ellipsis, {
                                text: '换算币制',
                                tooltip: true
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_272, [
                              (
                      scope.row.SettlementCurrencySystem != null &&
                      scope.row.SettlementCurrencySystem != undefined
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_273, _toDisplayString(_ctx.isString(scope.row.SettlementCurrencySystem.Code)), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_274, " 暂无数据 "))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementRate",
                          label: "汇率"
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_275, [
                              _createVNode(_component_miezz_text_ellipsis, {
                                text: '汇率',
                                tooltip: true
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_276, [
                              (
                      scope.row.SettlementRate != null &&
                      scope.row.SettlementRate != undefined
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_277, _toDisplayString(_ctx.isString(scope.row.SettlementRate)), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_278, " 暂无数据 "))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementPrice",
                          label: "换算金额"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_279, [
                              (
                      scope.row.SettlementPrice != null &&
                      scope.row.SettlementPrice != undefined
                    )
                                ? (_openBlock(), _createElementBlock("div", _hoisted_280, _toDisplayString(_ctx.isString(_ctx.formatNumber(scope.row.SettlementPrice))), 1))
                                : (_openBlock(), _createElementBlock("div", _hoisted_281, " 暂无数据 "))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementStatus",
                          label: "到账状态"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_282, [
                              (scope.row.SettlementStatus == 10)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_283, "部分到账"))
                                : (scope.row.SettlementStatus == 20)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_284, "已到账"))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_285, "未到账"))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Remark",
                          label: "备注"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_286, _toDisplayString(_ctx.isString(scope.row.Remark)), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          label: "操作",
                          width: "120"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", {
                              style: {"cursor":"pointer","color":"#fe995b"},
                              onClick: ($event: any) => (_ctx.onSearchBill(scope.row))
                            }, " 搜索账单 ", 8, _hoisted_287)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _hoisted_288,
              _createElementVNode("div", _hoisted_289, [
                _createVNode(_component_miezz_button_bar, {
                  modelValue: _ctx.statBottomButtons,
                  "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.statBottomButtons) = $event)),
                  isBackground: true,
                  onHandleClick: _ctx.handleClickStat
                }, null, 8, ["modelValue", "onHandleClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.batchBadSettlementForm != undefined)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 5,
            modelValue: _ctx.batchBadSettlementForm.Visiable,
            "onUpdate:modelValue": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.batchBadSettlementForm.Visiable) = $event)),
            "show-close": false,
            style: {"width":"90%"},
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "10px",
            "append-to-body": true
          }, {
            header: _withCtx(({ close }) => [
              _hoisted_290,
              _createElementVNode("div", _hoisted_291, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_292, [
                _createVNode(_component_el_form, {
                  ref: "refBatchBadSettlementForm",
                  model: _ctx.batchBadSettlementForm,
                  rules: _ctx.batchBadSettlementRules
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchBadSettlementForm.Sums, (p, index) => {
                      return (_openBlock(), _createBlock(_component_el_form_item, {
                        label: "",
                        style: {"margin-top":"-10px","font-weight":"900"},
                        "label-width": "0px",
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(p), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_component_el_table, {
                      ref: "batchBadSettlementTable",
                      border: "",
                      script: "",
                      data: _ctx.batchBadSettlementForm.Items
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "Total",
                          width: "180px",
                          label: "总金额",
                          "show-overflow-tooltip": true
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_293, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_294, _toDisplayString(scope.row.BillCurrencySystemCode) + _toDisplayString(_ctx.formatNumber(scope.row.Total)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "NoSettlementPrice",
                          width: "180px",
                          label: "待核销",
                          "show-overflow-tooltip": true
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_295, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_296, _toDisplayString(scope.row.BillCurrencySystemCode) + _toDisplayString(_ctx.formatNumber(scope.row.NoSettlementPrice)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "CollectionTitle",
                          label: "收款方",
                          width: "80px"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_297, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  (scope.row.IsBad == true || scope.row.IsBad != true)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_298, " — "))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "PaymentTitle",
                          label: "付款方",
                          width: "80px"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_299, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  (scope.row.IsBad == true || scope.row.IsBad != true)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_300, " — "))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "DisplayRate",
                          width: "80px",
                          label: "汇率"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_301, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  (scope.row.IsBad == true || scope.row.IsBad != true)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_302, " — "))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementDate",
                          label: "核销时间",
                          width: "200px"
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_303, [
                              _hoisted_304,
                              _createTextVNode(" 核销时间 "),
                              _createElementVNode("span", {
                                style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                                onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.onBatchSettlementTime(true)))
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Edit)
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_305, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                rules: _ctx.batchBadSettlementRules.SettlementDate,
                                prop: 'Items.' + scope.$index + '.SettlementDate'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: scope.row.SettlementDate,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.SettlementDate) = $event),
                                    format: "YYYY/MM/DD HH:mm",
                                    type: "datetime",
                                    style: {"width":"100% !important"},
                                    placeholder: "请选择"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Mode",
                          label: "核销方式",
                          width: "120px"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_306, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  (scope.row.IsBad == true || scope.row.IsBad != true)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_307, " 坏账核销 "))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Remark",
                          label: "备注"
                        }, {
                          header: _withCtx(() => [
                            _createTextVNode(" 备注 "),
                            _createElementVNode("span", {
                              style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                              onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.onBatchSettlementRemark(true)))
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Edit)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_308, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: scope.row.Remark,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Remark) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _hoisted_309,
              _createElementVNode("div", _hoisted_310, [
                _createVNode(_component_miezz_button_bar, {
                  modelValue: _ctx.batchBadSettlementBottomButtons,
                  "onUpdate:modelValue": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.batchBadSettlementBottomButtons) = $event)),
                  isBackground: true,
                  onHandleClick: _ctx.handleClickBatchBadSettlement
                }, null, 8, ["modelValue", "onHandleClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      (_ctx.batchSettlementForm != undefined)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 6,
            modelValue: _ctx.batchSettlementForm.Visiable,
            "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => ((_ctx.batchSettlementForm.Visiable) = $event)),
            "show-close": false,
            style: {"width":"90%"},
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            top: "10px",
            "append-to-body": true
          }, {
            header: _withCtx(({ close }) => [
              _hoisted_311,
              _createElementVNode("div", _hoisted_312, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_313, [
                _createVNode(_component_el_form, {
                  ref: "refBatchSettlementForm",
                  model: _ctx.batchSettlementForm,
                  rules: _ctx.batchSettlementRules
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchSettlementForm.Sums, (p, index) => {
                      return (_openBlock(), _createBlock(_component_el_form_item, {
                        label: "",
                        style: {"margin-top":"-10px","font-weight":"900"},
                        "label-width": "0px",
                        key: index
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", { innerHTML: p }, null, 8, _hoisted_314)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_component_el_table, {
                      ref: "batchSettlementTable",
                      border: "",
                      script: "",
                      data: _ctx.batchSettlementForm.Items
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "Total",
                          width: "130px",
                          label: "总金额",
                          "show-overflow-tooltip": true
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_315, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_316, _toDisplayString(scope.row.BillCurrencySystemCode) + _toDisplayString(_ctx.formatNumber(scope.row.Total)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "NoSettlementPrice",
                          width: "130px",
                          label: "待核销",
                          "show-overflow-tooltip": true
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_317, [
                              _createVNode(_component_el_form_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_318, _toDisplayString(scope.row.BillCurrencySystemCode) + _toDisplayString(_ctx.formatNumber(scope.row.NoSettlementPrice)), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "CollectionTitle",
                          label: "收款方"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_319,
                            _createTextVNode(" 收款方 "),
                            _createElementVNode("span", {
                              style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                              onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.onBatchSettlementTitle(0)))
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Edit)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_320, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                rules: _ctx.batchSettlementRules.CollectionTitle,
                                prop: 'Items.' + scope.$index + '.CollectionTitle'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: scope.row.CollectionTitle,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.CollectionTitle) = $event),
                                    filterable: "",
                                    placeholder: "请选择",
                                    "allow-create": "",
                                    clearable: "",
                                    onClear: ($event: any) => (_ctx.onChangeBatchCollectionTitle(scope.$index)),
                                    onChange: ($event: any) => (_ctx.onChangeBatchCollectionTitle(scope.$index))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.CollectionTitles, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.Value,
                                          label: item.Label,
                                          value: item.Value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onClear", "onChange"])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "PaymentTitle",
                          label: "付款方"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_321,
                            _createTextVNode(" 付款方 "),
                            _createElementVNode("span", {
                              style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                              onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.onBatchSettlementTitle(1)))
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Edit)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_322, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                rules: _ctx.batchSettlementRules.PaymentTitle,
                                prop: 'Items.' + scope.$index + '.PaymentTitle'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: scope.row.PaymentTitle,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.PaymentTitle) = $event),
                                    filterable: "",
                                    placeholder: "请选择",
                                    "allow-create": "",
                                    clearable: "",
                                    onClear: ($event: any) => (_ctx.onChangeBatchPaymentTitle(scope.$index)),
                                    onChange: ($event: any) => (_ctx.onChangeBatchPaymentTitle(scope.$index))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row.PaymentTitles, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.Value,
                                          label: item.Label,
                                          value: item.Value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onClear", "onChange"])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Price",
                          width: "260px",
                          label: "本次核销金额"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_323,
                            _createTextVNode(" 本次核销金额 ")
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_324, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                style: {"float":"left"},
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    style: {"display":"none"},
                                    modelValue: scope.row.CurrencySystemId,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.CurrencySystemId) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                  _createElementVNode("div", {
                                    onClick: ($event: any) => (_ctx.onBatchSettlementCurrency(scope.row)),
                                    style: {"width":"60px","float":"left","height":"30px","line-height":"30px","overflow":"hidden","text-overflow":"ellipsis","white-space":"nowrap","text-align":"left","cursor":"pointer","color":"#fe995b"}
                                  }, _toDisplayString(_ctx.isString(scope.row.CurrencySystem.Code)), 9, _hoisted_325)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                style: {"float":"left"},
                                label: "",
                                rules: _ctx.batchSettlementRules.Price,
                                prop: 'Items.' + scope.$index + '.Price'
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_326, [
                                    _createVNode(_component_miezz_input, {
                                      placeholder: "请填写",
                                      disabled: scope.row.IsZero,
                                      modelValue: scope.row.Price,
                                      "onUpdate:modelValue": ($event: any) => ((scope.row.Price) = $event),
                                      number: true,
                                      pattern: "[-0-9.,]",
                                      onChange: ($event: any) => (_ctx.onChangeBatchSettlementPrice(scope.row))
                                    }, null, 8, ["disabled", "modelValue", "onUpdate:modelValue", "onChange"])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "DisplayRate",
                          width: "120px",
                          label: "汇率"
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_327, [
                              _hoisted_328,
                              _createTextVNode(" 汇率 "),
                              _createElementVNode("span", {
                                style: _normalizeStyle([{"cursor":"pointer","margin-left":"2px"}, 
                      _ctx.isBatchSettlementTime == true
                        ? 'color: #00a5fb;'
                        : 'color: #666;'
                    ]),
                                onClick: _cache[45] || (_cache[45] = ($event: any) => (_ctx.onBatchSettlementRate()))
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Edit)
                                  ]),
                                  _: 1
                                })
                              ], 4)
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_329, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                rules: _ctx.batchSettlementRules.DisplayRate,
                                prop: 'Items.' + scope.$index + '.DisplayRate'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_input, {
                                    placeholder: "请填写",
                                    onChange: ($event: any) => (_ctx.onChangeBatchRate(scope.$index)),
                                    disabled: 
                        scope.row.CurrencySystemId != null &&
                        scope.row.CurrencySystemId != undefined &&
                        scope.row.CurrencySystemId ==
                          scope.row.BillCurrencySystemId
                          ? true
                          : false
                      ,
                                    modelValue: scope.row.DisplayRate,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.DisplayRate) = $event)
                                  }, null, 8, ["onChange", "disabled", "modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementDate",
                          label: "核销时间"
                        }, {
                          header: _withCtx(() => [
                            _createElementVNode("div", _hoisted_330, [
                              _hoisted_331,
                              _createTextVNode(" 核销时间 "),
                              _createElementVNode("span", {
                                style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                                onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.onBatchSettlementTime(false)))
                              }, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Edit)
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_332, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                rules: _ctx.batchSettlementRules.SettlementDate,
                                prop: 'Items.' + scope.$index + '.SettlementDate'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: scope.row.SettlementDate,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.SettlementDate) = $event),
                                    format: "YYYY/MM/DD HH:mm",
                                    type: "datetime",
                                    style: {"width":"100% !important"},
                                    placeholder: "请选择"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Mode",
                          label: "核销方式"
                        }, {
                          header: _withCtx(() => [
                            _createTextVNode(" 核销方式 "),
                            _createElementVNode("span", {
                              style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.onBatchSettlementMode()))
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Edit)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_333, [
                              (_openBlock(), _createBlock(_component_el_form_item, {
                                "label-width": "0px",
                                label: "",
                                key: _ctx.batchSettlementModeKey
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_select, {
                                    onChange: ($event: any) => (_ctx.onChangeBatchSettlementMode(scope.row)),
                                    modelValue: scope.row.Mode,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Mode) = $event),
                                    options: _ctx.EnumSettlementModeOption,
                                    clearable: false,
                                    valueKey: "Value",
                                    labelKey: "Label",
                                    style: {"width":"100% !important"}
                                  }, null, 8, ["onChange", "modelValue", "onUpdate:modelValue", "options"])
                                ]),
                                _: 2
                              }, 1024))
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Remark",
                          label: "备注"
                        }, {
                          header: _withCtx(() => [
                            _createTextVNode(" 备注 "),
                            _createElementVNode("span", {
                              style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                              onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.onBatchSettlementRemark(false)))
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Edit)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_334, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: scope.row.Remark,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Remark) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementAnnexs",
                          label: "凭证"
                        }, {
                          header: _withCtx(() => [
                            _createTextVNode(" 凭证 "),
                            _createElementVNode("span", {
                              style: {"cursor":"pointer","margin-left":"2px","color":"#00a5fb"},
                              onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.onBatchSettlementAnnex(false)))
                            }, [
                              _createVNode(_component_el_icon, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Edit)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_335, [
                              _createVNode(_component_el_form_item, {
                                "label-width": "0px",
                                label: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_miezz_upload, {
                                    isTip: false,
                                    multiple: true,
                                    modelValue: scope.row.SettlementAnnexs,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.SettlementAnnexs) = $event),
                                    path: "bill/file",
                                    accept: "file/*",
                                    prop: "Url",
                                    maxSize: 5 * 1024 * 1024
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1024)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _hoisted_336,
              _createElementVNode("div", _hoisted_337, [
                _createVNode(_component_miezz_button_bar, {
                  modelValue: _ctx.batchSettlementBottomButtons,
                  "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.batchSettlementBottomButtons) = $event)),
                  isBackground: true,
                  onHandleClick: _ctx.handleClickBatchSettlement
                }, null, 8, ["modelValue", "onHandleClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.dialogVisible,
        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.dialogVisible) = $event)),
        title: "提示",
        width: "45%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      }, {
        default: _withCtx(() => [
          _hoisted_338,
          _createElementVNode("div", _hoisted_339, [
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[52] || (_cache[52] = ($event: any) => (_ctx.onCloseTip()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.statDialogVisible,
        "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.statDialogVisible) = $event)),
        title: "提示",
        width: "45%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            innerHTML: _ctx.list.DefaultTip
          }, null, 8, _hoisted_340),
          _createElementVNode("div", _hoisted_341, [
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.onCloseStatTip()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.setinvoiceForm.Visiable,
        "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.setinvoiceForm.Visiable) = $event)),
        "show-close": false,
        title: "关联发票",
        width: "45%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      }, {
        header: _withCtx(({ close }) => [
          _hoisted_342,
          _createElementVNode("div", _hoisted_343, [
            _createVNode(_component_el_icon, {
              style: {"cursor":"pointer"},
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "refSetinvoiceForm",
              model: _ctx.setinvoiceForm,
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "发票号码",
                  prop: "InvoiceId",
                  rules: [
              {
                required: true,
                message: '信息不能为空',
                trigger: 'blur',
              },
            ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _ctx.setinvoiceForm.InvoiceId,
                      "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.setinvoiceForm.InvoiceId) = $event)),
                      filterable: "",
                      placeholder: "请选择",
                      onChange: _ctx.onChangeInvoiceId
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoices, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.Value,
                            label: item.Label,
                            value: item.Value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "onChange"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_344, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.onSaveSetInvoiceForm()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.onCloseSetInvoiceForm()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.batchSettlementTimeForm.Visiable,
        "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.batchSettlementTimeForm.Visiable) = $event)),
        "show-close": false,
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      }, {
        header: _withCtx(({ close }) => [
          _hoisted_345,
          _createElementVNode("div", _hoisted_346, [
            _createVNode(_component_el_icon, {
              style: {"cursor":"pointer"},
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "refbatchSettlementTimeForm",
              model: _ctx.batchSettlementTimeForm,
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "核销时间",
                  prop: "SettlementTime",
                  rules: [
              {
                required: true,
                message: '信息不能为空',
                trigger: 'blur',
              },
            ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.batchSettlementTimeForm.SettlementTime,
                      "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.batchSettlementTimeForm.SettlementTime) = $event)),
                      format: "YYYY/MM/DD HH:mm",
                      type: "datetime",
                      style: {"width":"100% !important"},
                      placeholder: "请选择"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_347, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.onSaveBatchSettlementTime()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.onCloseBatchSettlementTime()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.batchSettlementTitleForm.Visiable,
        "onUpdate:modelValue": _cache[68] || (_cache[68] = ($event: any) => ((_ctx.batchSettlementTitleForm.Visiable) = $event)),
        "show-close": false,
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      }, {
        header: _withCtx(({ close }) => [
          _hoisted_348,
          _createElementVNode("div", _hoisted_349, [
            _createVNode(_component_el_icon, {
              style: {"cursor":"pointer"},
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "refbatchSettlementTitleForm",
              model: _ctx.batchSettlementTitleForm,
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: 
              _ctx.batchSettlementTitleForm.Type == 0 ? '收款方抬头' : '付款方抬头'
            ,
                  prop: "Title",
                  rules: [
              {
                required: true,
                message: '信息不能为空',
                trigger: 'blur',
              },
            ]
                }, {
                  default: _withCtx(() => [
                    (_ctx.batchSettlementTitleForm.Type == 0)
                      ? (_openBlock(), _createBlock(_component_el_select, {
                          key: 0,
                          modelValue: _ctx.batchSettlementTitleForm.Title,
                          "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.batchSettlementTitleForm.Title) = $event)),
                          filterable: "",
                          placeholder: "请选择"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchSettlementForm.CollectionTitles, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.Value,
                                label: item.Label,
                                value: item.Value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock(_component_el_select, {
                          key: 1,
                          modelValue: _ctx.batchSettlementTitleForm.Title,
                          "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.batchSettlementTitleForm.Title) = $event)),
                          filterable: "",
                          placeholder: "请选择"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.batchSettlementForm.PaymentTitles, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.Value,
                                label: item.Label,
                                value: item.Value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]))
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_350, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[66] || (_cache[66] = ($event: any) => (_ctx.onSaveBatchSettlementTitle()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[67] || (_cache[67] = ($event: any) => (_ctx.onCloseBatchSettlementTitle()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.batchSettlementTimeForm.RateVisiable,
        "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.batchSettlementTimeForm.RateVisiable) = $event)),
        "show-close": false,
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      }, {
        header: _withCtx(({ close }) => [
          _hoisted_351,
          _createElementVNode("div", _hoisted_352, [
            _createVNode(_component_el_icon, {
              style: {"cursor":"pointer"},
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "refbatchSettlementRateForm",
              model: _ctx.batchSettlementTimeForm,
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "汇率",
                  prop: "DisplayRate",
                  rules: [
              {
                required: true,
                message: '信息不能为空',
                trigger: 'blur',
              },
            ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.batchSettlementTimeForm.DisplayRate,
                      "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.batchSettlementTimeForm.DisplayRate) = $event)),
                      onChange: _cache[70] || (_cache[70] = ($event: any) => (_ctx.onChangeBatchSettlementRate()))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_353, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[71] || (_cache[71] = ($event: any) => (_ctx.onSaveBatchSettlementRate()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[72] || (_cache[72] = ($event: any) => (_ctx.onCloseBatchSettlementRate()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.batchSettlementAnnexForm.Visiable,
        "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.batchSettlementAnnexForm.Visiable) = $event)),
        "show-close": false,
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      }, {
        header: _withCtx(({ close }) => [
          _hoisted_354,
          _createElementVNode("div", _hoisted_355, [
            _createVNode(_component_el_icon, {
              style: {"cursor":"pointer"},
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "refBatchSettlementAnnex",
              model: _ctx.batchSettlementAnnexForm,
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "凭证",
                  prop: "SettlementAnnexs"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_upload, {
                      multiple: true,
                      modelValue: _ctx.batchSettlementAnnexForm.SettlementAnnexs,
                      "onUpdate:modelValue": _cache[74] || (_cache[74] = ($event: any) => ((_ctx.batchSettlementAnnexForm.SettlementAnnexs) = $event)),
                      path: "bill/file",
                      accept: "file/*",
                      prop: "Url",
                      maxSize: 5 * 1024 * 1024
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_356, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[75] || (_cache[75] = ($event: any) => (_ctx.onSaveBatchSettlementAnnex()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[76] || (_cache[76] = ($event: any) => (_ctx.onCloseBatchSettlementAnnex()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.batchSettlementRemarkForm.Visiable,
        "onUpdate:modelValue": _cache[81] || (_cache[81] = ($event: any) => ((_ctx.batchSettlementRemarkForm.Visiable) = $event)),
        "show-close": false,
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      }, {
        header: _withCtx(({ close }) => [
          _hoisted_357,
          _createElementVNode("div", _hoisted_358, [
            _createVNode(_component_el_icon, {
              style: {"cursor":"pointer"},
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "refBatchSettlementRamark",
              model: _ctx.batchSettlementRemarkForm,
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "备注",
                  prop: "Remark",
                  rules: [
              {
                required: true,
                message: '信息不能为空',
                trigger: 'blur',
              },
            ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _ctx.batchSettlementRemarkForm.Remark,
                      "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.batchSettlementRemarkForm.Remark) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_359, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[79] || (_cache[79] = ($event: any) => (_ctx.onSaveBatchSettlementRemark()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.onCloseBatchSettlementRemark()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.checkStatusForm.Visiable,
        "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.checkStatusForm.Visiable) = $event)),
        "show-close": false,
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      }, {
        header: _withCtx(({ close }) => [
          _hoisted_360,
          _createElementVNode("div", _hoisted_361, [
            _createVNode(_component_el_icon, {
              style: {"cursor":"pointer"},
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "refCheckStatusForm",
              model: _ctx.checkStatusForm,
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "状态",
                  prop: "Status",
                  rules: [
              {
                required: true,
                message: '信息不能为空',
                trigger: 'blur',
              },
            ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_select, {
                      modelValue: _ctx.checkStatusForm.Status,
                      "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.checkStatusForm.Status) = $event)),
                      options: _ctx.EnumBillCheckStatusOption,
                      clearable: false,
                      valueKey: "Value",
                      labelKey: "Label",
                      style: {"width":"100% !important"}
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_362, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[83] || (_cache[83] = ($event: any) => (_ctx.onSaveCheckStatus()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[84] || (_cache[84] = ($event: any) => (_ctx.onCloseCheckStatus()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.batchSettlementModeForm.Visiable,
        "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.batchSettlementModeForm.Visiable) = $event)),
        "show-close": false,
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true
      }, {
        header: _withCtx(({ close }) => [
          _hoisted_363,
          _createElementVNode("div", _hoisted_364, [
            _createVNode(_component_el_icon, {
              style: {"cursor":"pointer"},
              onClick: close
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CloseBold)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_el_form, {
              ref: "refBatchSettlementMode",
              model: _ctx.batchSettlementModeForm,
              "label-width": "120px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "核销方式",
                  prop: "Mode",
                  rules: [
              {
                required: true,
                message: '信息不能为空',
                trigger: 'blur',
              },
            ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_miezz_select, {
                      modelValue: _ctx.batchSettlementModeForm.Mode,
                      "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.batchSettlementModeForm.Mode) = $event)),
                      options: _ctx.EnumSettlementModeOption,
                      clearable: false,
                      valueKey: "Value",
                      labelKey: "Label",
                      style: {"width":"100% !important"}
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _createElementVNode("div", _hoisted_365, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: _cache[87] || (_cache[87] = ($event: any) => (_ctx.onSaveBatchSettlementMode()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("保存")
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              size: "small",
              onClick: _cache[88] || (_cache[88] = ($event: any) => (_ctx.onCloseBatchSettlementMode()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("关闭")
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.partSettlementForm != undefined)
        ? (_openBlock(), _createBlock(_component_el_dialog, {
            key: 7,
            modelValue: _ctx.partSettlementForm.Visiable,
            "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.partSettlementForm.Visiable) = $event)),
            "show-close": false,
            style: {"width":"60%"},
            top: "20px",
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "append-to-body": true
          }, {
            header: _withCtx(({ close }) => [
              _hoisted_366,
              _createElementVNode("div", _hoisted_367, [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_CloseBold)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_368, [
                _createVNode(_component_el_form, {
                  ref: "refPartSettlementForm",
                  model: _ctx.partSettlementForm,
                  rules: _ctx.partSettlementRules
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table, {
                      ref: "statTable",
                      "tree-props": { children: 'Child', hasChildren: 'hasChildren' },
                      "row-key": "Id",
                      "default-expand-all": true,
                      data: _ctx.partSettlementForm.Item
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementPrice",
                          label: "待核销"
                        }, {
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_369, _toDisplayString(scope.row.SettlementCurrencySystemCode) + _toDisplayString(scope.row.SettlementPrice), 1)
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Price",
                          label: "核销币制"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_370
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_371, [
                              _createVNode(_component_el_form_item, {
                                label: "",
                                "label-width": "0px",
                                rules: _ctx.partSettlementRules.CurrencySystemId,
                                prop: 'Item.' + scope.$index + '.CurrencySystemId'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_select, {
                                    modelValue: scope.row.CurrencySystemId,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.CurrencySystemId) = $event),
                                    filterable: "",
                                    placeholder: "请选择",
                                    "allow-create": "",
                                    onChange: ($event: any) => (_ctx.onChangePartSettlementCurrency(scope.$index))
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currencys, (item) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: item.Value,
                                          label: item.Label,
                                          value: item.Value
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["modelValue", "onUpdate:modelValue", "onChange"])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Price",
                          label: "本次核销"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_372
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_373, [
                              _createVNode(_component_el_form_item, {
                                label: "",
                                "label-width": "0px",
                                rules: _ctx.partSettlementRules.Price,
                                prop: 'Item.' + scope.$index + '.Price'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: scope.row.Price,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Price) = $event)
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "SettlementTime",
                          label: "本次核销"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_374
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_375, [
                              _createVNode(_component_el_form_item, {
                                label: "",
                                "label-width": "0px",
                                rules: _ctx.partSettlementRules.SettlementTime,
                                prop: 'Item.' + scope.$index + '.SettlementTime'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_date_picker, {
                                    modelValue: scope.row.SettlementTime,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.SettlementTime) = $event),
                                    format: "YYYY/MM/DD HH:mm",
                                    type: "datetime",
                                    style: {"width":"100% !important"},
                                    placeholder: "请选择"
                                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_table_column, {
                          prop: "Rate",
                          label: "汇率"
                        }, {
                          header: _withCtx(() => [
                            _hoisted_376
                          ]),
                          default: _withCtx((scope) => [
                            _createElementVNode("div", _hoisted_377, [
                              _createVNode(_component_el_form_item, {
                                label: "",
                                "label-width": "0px",
                                rules: _ctx.partSettlementRules.Rate,
                                prop: 'Item.' + scope.$index + '.Rate'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_input, {
                                    modelValue: scope.row.Rate,
                                    "onUpdate:modelValue": ($event: any) => ((scope.row.Rate) = $event),
                                    disabled: 
                        scope.row.SettlementCurrencySystemId ==
                        scope.row.CurrencySystemId
                          ? true
                          : false
                      
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                ]),
                                _: 2
                              }, 1032, ["rules", "prop"])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["data"])
                  ]),
                  _: 1
                }, 8, ["model", "rules"])
              ]),
              _hoisted_378,
              _createElementVNode("div", _hoisted_379, [
                _createVNode(_component_miezz_button_bar, {
                  modelValue: _ctx.partSettlementBottomButtons,
                  "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.partSettlementBottomButtons) = $event)),
                  isBackground: true,
                  onHandleClick: _ctx.handleClickPartSettlement
                }, null, 8, ["modelValue", "onHandleClick"])
              ])
            ]),
            _: 1
          }, 8, ["modelValue"]))
        : _createCommentVNode("", true)
    ])), [
      [
        _directive_loading,
        _ctx.isLoading,
        void 0,
        {
          fullscreen: true,
          lock: true
        }
      ]
    ]),
    _createVNode(_component_miezz_currency, {
      defaultRate: '美元',
      isRate: false,
      defaultCurrency: '美元',
      ref: "Currency",
      onOnSelectCurrency: _ctx.onSelectCurrency
    }, null, 8, ["onOnSelectCurrency"]),
    (_ctx.accountPeriodRuleForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 0,
          modelValue: _ctx.accountPeriodRuleForm.Visiable,
          "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.accountPeriodRuleForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_380,
            _createElementVNode("div", _hoisted_381, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_el_form, {
                ref: "refAccountPeriodRuleForm",
                model: _ctx.accountPeriodRuleForm
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "记账起始时间",
                    prop: "Time",
                    rules: [
            {
              required: true,
              message: '信息不能为空',
              trigger: 'blur',
            },
          ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.accountPeriodRuleForm.Time,
                        "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.accountPeriodRuleForm.Time) = $event)),
                        style: {"width":"100% !important"},
                        placeholder: "请选择"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "账期（天数）",
                    prop: "AccountPeriod",
                    rules: [
            {
              required: true,
              message: '信息不能为空',
              trigger: 'blur',
            },
          ]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.accountPeriodRuleForm.AccountPeriod,
                        "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.accountPeriodRuleForm.AccountPeriod) = $event)),
                        onChange: _cache[94] || (_cache[94] = ($event: any) => (_ctx.onChangePeriod())),
                        placeholder: "请填写"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            _hoisted_382,
            _createElementVNode("div", _hoisted_383, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.accountPeriodBottomButtons,
                "onUpdate:modelValue": _cache[95] || (_cache[95] = ($event: any) => ((_ctx.accountPeriodBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickAccountPeriod
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true),
    (_ctx.startDateRuleForm != undefined)
      ? (_openBlock(), _createBlock(_component_el_dialog, {
          key: 1,
          modelValue: _ctx.startDateRuleForm.Visiable,
          "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.startDateRuleForm.Visiable) = $event)),
          "show-close": false,
          style: {"width":"40%"},
          "close-on-click-modal": false,
          "close-on-press-escape": false,
          "append-to-body": true
        }, {
          header: _withCtx(({ close }) => [
            _hoisted_384,
            _createElementVNode("div", _hoisted_385, [
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: close
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CloseBold)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref: "refTimeRuleForm",
              model: _ctx.startDateRuleForm
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "财务周期",
                  prop: "Time",
                  rules: [
          {
            required: true,
            message: '信息不能为空',
            trigger: 'blur',
          },
        ]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_date_picker, {
                      modelValue: _ctx.startDateRuleForm.Time,
                      "onUpdate:modelValue": _cache[97] || (_cache[97] = ($event: any) => ((_ctx.startDateRuleForm.Time) = $event)),
                      style: {"width":"100% !important"},
                      "value-format": "YYYY/MM",
                      type: "month",
                      format: "YYYY/MM",
                      placeholder: "请选择"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model"]),
            _hoisted_386,
            _createElementVNode("div", _hoisted_387, [
              _createVNode(_component_miezz_button_bar, {
                modelValue: _ctx.startDateBottomButtons,
                "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.startDateBottomButtons) = $event)),
                isBackground: true,
                onHandleClick: _ctx.handleClickStartDate
              }, null, 8, ["modelValue", "onHandleClick"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}